const companyName = import.meta.env.VITE_COMPANY_NAME;

import errors from './api-errors/fa.js';
import businessDirectory from './business-directory/fa.js';
import logTemplates from './log-templates/fa.js';
import permission from './permission/fa.js';

// @ts-ignore
export default {
  ...errors,
  ...permission,
  ...businessDirectory,
  ...logTemplates,
  NavaTel: companyName,
  Navatel: companyName,
  navatel: companyName,
  logout: 'خروج',
  type: 'نوع',
  service: 'خدمت',
  opps: 'ای وای',
  thisPageYouAreLookingForCouldNotBeFound: ' صفحه مورد نظر شما یافت نشد',
  goBackToHome: 'بازگشت به خانه',
  goBackToTicket: 'بازگشت به تیکت‌ها',
  goBackToLead: 'بازگشت به سرنخ‌ها',
  goBackToDeal: 'بازگشت به فرصت‌های فروش',
  goBackToPeople: 'بازگشت به اشخاص',
  goBackToCompanies: 'بازگشت به شرکت‌ها',
  themeColor: 'تم رنگ روشن',
  themeDarkColor: 'تم رنگ تیره',
  home: 'خانه',
  userProfile: 'مشخصات کاربر',
  myProfile: 'پروفایل من',
  noState: 'نامشخص',
  accountSettings: 'تنظیمات حساب کاربری',
  myInbox: 'پیام های من',
  messagesEmails: 'پیام ها و ایمیل ها',
  myTasks: 'تسک های من',
  toDoAndDailyTasks: 'وظایف و کارهای روزانه',
  notifications: 'اعلان ها',
  seeAllNotifications: 'مشاهده همه اعلان ها',
  usersSettings: 'تنظیمات کاربری',
  userManagement: 'تعریف کاربر',
  errorInUserManagement: 'خطا در تعریف کاربر',
  listOfUsers: 'لیست کاربران',
  roleManagement: 'مدیریت نقش',
  messagesToOperators: 'ارسال پیام به کاربران',
  crm: 'مدیریت ارتباط مشتری',
  CRM: 'مدیریت ارتباط مشتری',
  people: 'اشخاص',
  companies: 'شرکت‌ها',
  callSetting: 'تنظیمات تماس',
  definitionCallForwardingNumber: 'تعریف شماره کال فوروارد',
  uploadRecording: 'بارگذاری فایل صوتی',
  uploadDate: 'تاریخ بارگذاری',
  format: 'فرمت',
  file: 'فایل',
  queue: 'صف',
  queueManagement: 'مدیریت صف',
  manageIvr: 'مدیریت IVR',
  noIvr: 'هنوز منو ای ثبت نشده.',
  setTimeCondition: 'تعیین شروط زمانی',
  manageVoicemail: 'مدیریت پیام‌های صوتی',
  blackList: 'لیست سیاه',
  callDestination: 'مقصد تماس',
  ratings: 'نظرسنجی',
  monitoring: 'مانیتورینگ',
  dashboard: 'پیشخوان',
  wallboard: 'والبورد',
  liveCall: 'نمایش زنده تماس‌ها',
  usersStatus: 'وضعیت کاربران',
  hangupReason: 'سوابق تماس',
  answeredNumber: 'تعداد تماس‌های پاسخ‌داده‌شده',
  calls: 'وضعیت تماس‌',
  missedNumber: 'تعداد تماس‌های بی‌پاسخ',
  totalCallDuration: 'مجموع زمان مکالمه',
  totalMissedWaitngDuration: 'مجموع زمان انتظار در زمان قطع ارتباط',
  totalAnswereddWaitngDuration: 'مجموع زمان انتظار در تماس‌های پاسخ داده‌شده',
  operatorActivity: 'عملکرد پاسخگویی کاربر',
  cdr: 'رکورد مکالمات',
  fullCdrs: 'گزارش پیشرفته',
  scatteirng: 'نمودار پراکندگی تماس‌ها',
  rating: 'نتایج نظر سنجی مکالمات',
  cost: 'هزینه',
  customerWaitChart: 'نمودار صبر مشتری',
  insertNewTicket: 'ایجاد تیکت',
  transferToAnotherOperator: 'انتقال به اوپراتور دیگر',
  ticketAssignModalText: 'کارشناس پیگیری با موفقیت ثبت شد.',
  transfer: 'انتقال',
  ticketsList: 'مشاهده تیکت‌های ارسالی',
  ticketList: 'لیست تیکت‌ها',
  connectToCrm: 'اتصال به CRM',
  crmNumbers: 'تعریف شماره مجاز CRM',
  crmStructure: 'ساختار CRM',
  CRMlinks: 'لینک های اتصال به CRM',
  noCrmSetting: 'ساختاری تعریف نشده است.',
  noCrmNumber: 'شماره ای تعریف نشده است.',
  fax: 'فکس',
  insertNewFax: 'ایجاد فکس',
  faxDate: ' تاریخ فکس',
  faxType: 'نوع فکس',
  sendFax: 'ارسال فکس',
  headNumber: 'سر شماره',
  reportOfSubmittedFax: 'فکس‌های ارسالی',
  reportOfReceivedFax: 'فکس‌های دریافتی',
  webchat: 'وب چت',
  insertNewWebsit: 'تعریف وب‌سایت',
  insertOperatorNumber: 'تعریف شماره اپراتور',
  insertOperatorNumberTitle: 'تعریف شماره اپراتور',
  manageOperator: 'اپراتورها',
  manageOperatorTitle: 'اپراتور‌ها',
  manageRoles: 'مدیریت نقش‌ها',
  department: 'دپارتمان',
  definitionDepartments: 'تعریف دپارتمان‌ها',
  enterDepartmentName: 'نام دلخواه خود را وارد کنید.',
  customize: 'تنظیمات و شخصی سازی',
  noSite: 'سایتی برای نمایش تنظیمات وجود ندارد.',
  conversations: 'گفتگوها',
  noItemExist: 'آیتمی برای انتخاب موجود نیست.',
  firstSelectWebsite: 'ابتدا وب‌سایت را انتخاب کنید.',
  numberDeleteSuccessfully: 'شماره با موفقیت حذف شد.',
  createLinkGuid: 'برای ایجاد لینک جلسه کلیک کنید.',
  linkAddress: 'آدرس لینک',
  copyNotPossible: 'عدم پشتیبانی از کپی کردن',
  linkType: 'نوع لینک',
  meetTitle: 'عنوان جلسه',
  meetParticipantsNumber: 'تعداد شرکت کنندگان',
  recordDeleteModalTitle: 'حذف رکورد',
  videoConference: 'ویدئو کنفرانس',
  createLinkTitle: 'ایجاد لینک',
  products: 'محصولات',
  connectToWhatsapp: 'اتصال به واتس‌اپ ',
  whatsappAccounts: 'حساب‌های واتس‌اپ ',
  whatsapp: 'واتس‌اپ',
  whatsappMessages: 'پیامرسانی واتس‌اپ',
  enterWhatsapp: 'ورود به واتس‌اپ',
  whatsappAdd: 'ایجاد حساب واتس‌اپ',
  whatsappAddAccount: 'افزودن حساب واتس‌اپ ',
  noAccountYet:
    '  شما تاکنون حساب واتس‌اپ در سیستم تعریف نکرده‌اید! برای این منظور روی دکمه زیر کلیک نمائید. ',
  addWhatsAppAccount:
    'راهنما با کلیک برروی دکمه افزودن حساب واتس‌اپ، امکان تعریف حساب جدید وجود دارد.',
  addWhatsAppAccountText: 'افزودن حساب واتس‌اپ ',
  countryCode: 'کد کشور',
  profileTitle: 'عنوان پروفایل',
  profileTitlePlaceHolder: 'عنوان مورد نظر خود را وارد کنید',
  lineNumber: 'شماره خط',
  enterYourWhatsappLine: 'شماره خط واتس‌اپ خود را وارد کنید',
  crmContactUpdate: 'به‌روز رسانی مخاطبین CRM',
  contactAvatarUpdate: ' به‌روزرسانی آواتار مخاطب ',
  crmContactAutoCreate: 'ایجاد خودکار مخاطبین CRM',
  samplePhone: '09129876543',
  optional: ' (اختیاری) ',
  inactive: 'غیرفعال',
  connected: 'متصل',
  qrcodeScan: 'اسکن QR Code',
  whatsappconnect1: 'واتس‌اپ را روی گوشی خود باز کنید.',
  whatsappconnect21: 'روی منو',
  whatsappconnect22: 'یا تنظیمات',
  whatsappconnect23: 'کلیک کنید.',
  whatsappconnect3: 'کد روبرو را اسکن کنید.',
  newCloseText: 'خیر، بازگشت',
  newConfirmText: 'بله، حذف',
  whatsappdelete1: 'آیا از حذف حساب واتس‌اپ',
  whatsappdelete2: 'مطمئن هستید؟',
  whatsappcreatesuccess: 'حساب واتس‌اپ با موفقیت ایجاد شد.',
  whatsappaccountmanagement: 'مدیریت حساب‌های واتس‌اپ',
  newAccountAya: 'آیا میخواهید یک حساب دیگر ایجاد کنید؟',
  newAccount: 'ایجاد حساب جدید',
  editConfirmed: 'تائید ویرایش',
  samplePlaceHolder: 'دپارتمان توسعه فنی',
  receiver: 'دریافت‌کننده',
  receiving: 'دریافتی',
  whatsAppFileInputMessage: 'فقط فایل‌های فرمت JPEG, PNG, SVG تا حجم 25MB.',
  productFileInputMessage: 'فقط فایل‌های فرمت JPEG, PNG  تا حجم 1MB.',
  enterMessageText: 'متن پیام خود را وارد کنید!',
  messageText: 'متن پیام',
  sendWhatsappMessage: 'ارسال پیام واتس‌اپ',
  draft: 'پیش‌نویس',
  noWhatsAppMessageYet:
    'شما تاکنون پیامی از این حساب واتس‌اپ ارسال نکرده‌اید! ',
  messageSentSuccessfully: 'پیام با موفقیت ارسال شد.',
  meetDate: 'تاریخ برگزاری',
  meetDuration: 'مدت جلسه',
  recordDeleteModalText: 'آیا برای پاک کردن رکورد مورد نظر اطمینان دارید؟',
  meetListPageTitle: 'لیست رویدادها',
  writeDown: 'پیام خود را یادداشت کنید..',
  chatPage: 'صفحه چت',
  willScanLater: 'بعدا اسکن می‌کنم',
  deleteWhatsappNumber: 'حذف حساب واتس‌اپ',
  history: 'تاریخچه',
  productHistory: 'تاریخچه محصول',
  createLink: 'ایجاد لینک',
  linkTitle: 'عنوان جلسه',
  invoicePreInvoice: 'فاکتور / پیش‌فاکتور',
  invoiceAndPreInvoice: 'فاکتور و پیش‌فاکتور',
  invoice: 'فاکتور',
  preinvoice: 'پیش‌فاکتور',
  preInvoice: 'پیش‌فاکتور',
  documentNumber: 'شماره سند',
  documentType: 'نوع سند',
  customerType: 'نوع خریدار',
  expirationDate: 'تاریخ انقضا',
  paymentDate: 'تاریخ پرداخت',
  documentDate: 'تاریخ سند',
  price: 'مبلغ',
  addInvoiceText:
    'هنوز فاکتور یا پیش‌فاکتور ایجاد نشده است، برای ایجاد فاکتور روی دکمه زیر کلیک کنید.',
  addPreinvoiceText: 'برای ایجاد پیش‌فاکتور روی دکمه زیر کلیک کنید.',
  notFoundInvoice: 'فاکتور یا پیش‌فاکتوری با مشخصات وارد شده یافت نشد.',
  preinvoiceCurrency: 'ارز پیش‌فاکتور',
  invoiceCurrency: 'ارز فاکتور',
  noInvoiceSubmittedForThisProfile:
    'برای این پروفایل، فاکتور یا پیش‌فاکتور ثبت نشده است!',
  naturalis: 'حقیقی',
  juridica: 'حقوقی',
  telephone: 'تلفن',
  productName: 'نام محصول',
  unitPrice: 'مبلغ واحد',
  count: 'تعداد',
  numberValue: 'عدد',
  discountType: 'نوع تخفیف',
  amount: 'مقدار',
  discount: 'تخفیف',
  tax: 'مالیات و عوارض',
  totalPrice: 'مبلغ کل',
  percentage: 'درصد',
  preinvoiceDescription: 'توضیحات پیش‌فاکتور',
  finalPrice: 'مبلغ نهایی',
  totalDiscount: 'مجموع تخفیف',
  totalTax: 'مجموع مالیات و عوارض',
  otherCosts: 'هزینه‌های دیگر',
  addNewRow: 'افزودن سطر جدید',
  amountToPay: 'مبلغ قابل پرداخت',
  amountToPayNumber: 'مبلغ قابل پرداخت (به عدد)',
  amountToPayWord: 'مبلغ قابل پرداخت (به حروف)',
  revocation: 'ابطال',
  revocationed: 'ابطال شده',
  convertToInvoice: 'تبدیل به فاکتور',
  advanceInvoices: 'پیش‌فاکتورها',
  deletePreinvoice: 'حذف پیش‌فاکتور',
  deleteInvoice: 'حذف فاکتور',
  deletePreinvoiceText: 'آیا از حذف پیش‌‌فاکتور {item} مطمئن هستید؟',
  deleteInvoiceText: 'آیا از حذف فاکتور {item} مطمئن هستید؟',
  deletePreinvoiceSuccessfully: 'پیش‌فاکتور با موفقیت حذف شد',
  deleteInvoiceSuccessfully: 'فاکتور با موفقیت حذف شد',
  revocationText: 'آیا از ابطال فاکتور شماره {item} اطمینان دارید؟',
  revocationNoteText: 'ابطال ‌فاکتور به معنی عودت مبلغ آن به مشتری است.',
  preinvoiceNumber: 'شماره پیش‌فاکتور',
  invoiceNumber: 'شماره فاکتور',
  expirationDuration: 'مدت انقضا',
  expirationDurationText: '{day} روز بعد از ارسال پیش‌فاکتور',
  saveDraft: 'ذخیره در پیش‌نویس',
  billingPreInvoice: 'ارسال پیش‌فاکتور',
  billing: 'ارسال فاکتور',
  saveInvoice: 'ذخیره فاکتور',
  saveAndSendInvoice: 'ذخیره و ارسال فاکتور',
  sureToSaveAndSendInvoice: 'آیا از ذخیره و ارسال فاکتور مطمئن هستید؟',
  sureToSaveInvoice: 'آیا از ذخیره فاکتور مطمئن هستید؟',
  canNotUpdateInvoice:
    ' توجه بعد از ذخیره فاکتور قادر به ویرایش آن نخواهید بود.',
  yesSaveAndSend: 'بله، ذخیره و ارسال',
  yesSave: 'بله، ذخیره',
  preinvoiceSaveToDraftSuccessfully:
    'پیش‌فاکتوربا موفقیت در پیش‌نویس ذخیره شد.',
  invoiceSavedSuccessfully: 'فاکتور با موفقیت ذخیره شد',
  preInvoiceSavedSuccessfully: 'پیش‌فاکتور با موفقیت ذخیره شد',
  invoiceSendSuccessfully: 'فاکتور با موفقیت ارسال شد',
  preinvoiceRevocationSuccessfully: 'فاکتور با موفقیت ابطال شد.',
  invoiceHistory: 'تاریخچه فاکتور',
  preinvoiceHistory: 'تاریخچه پیش‌فاکتور',
  factorSearchText: 'جستجوی شماره  سند، نام خریدار',
  invoiceAndPreinvoiceSetting: 'تنظیمات پیش‌فاکتور و فاکتور',
  template: 'قالب',
  advanceSetting: 'تنظیمات پیشرفته',
  ecoNumber: 'شماره اقتصادی',
  enterYourAddress: 'آدرس را وارد کنید',
  saveSettings: 'ذخیره تنظیمات',
  vertical: 'عمودی',
  horizontal: 'افقی',
  displayType: 'نوع نمایش',
  uploadCompanyLogo: 'بارگذاری لوگوی شرکت',
  uploadBackground: 'بارگذاری تصویر پس‌زمینه',
  uploadStampAndSignature: 'بارگذاری مهر و امضا',
  distanceFromTop: 'فاصله از بالا (به پیکسل)',
  distanceFromBottom: 'فاصله از پایین (به پیکسل)',
  distanceFromRight: 'فاصله از راست (به پیکسل)',
  distanceFromLeft: 'فاصله از چپ (به پیکسل)',
  displayLogoOnPreinvoice: 'نمایش لوگوی شرکت در پیش‌فاکتور',
  displayLogoOnInvoice: 'نمایش لوگوی شرکت در فاکتور',
  displayStampAndSignatureOnPreinvoice: 'نمایش مهر و امضا در پیش‌فاکتور',
  displayStampAndSignatureOnInvoice: 'نمایش مهر و امضا در فاکتور',
  displayBackgroundInPreinvoice: 'نمایش تصویر پس‌زمینه در پیش‌فاکتور',
  displayBackgroundInInvoice: 'نمایش تصویر پس‌زمینه در فاکتور',
  preinvoiceNumberFormat: 'فرمت شماره پیش‌فاکتور',
  invoiceNumberFormat: 'فرمت شماره فاکتور',
  preinvoiceStartingNumber: 'شماره شروع پیش فاکتور ',
  invoiceStartingNumber: 'شماره شروع فاکتور ',
  defaultTax: 'مقدار پیش فرض درصد مالیات',
  showTaxColumn: 'نمایش ستون مالیات',
  showProductCode: 'نمایش کد کالا',
  displayCountAndAmountOfUnits: 'نمایش تعداد و مبلغ واحد',
  showDiscountColumn: 'نمایش ستون تخفیف',
  createQrInPdf: 'ایجاد QR در خروجی PDF',
  invoiceDescription: 'توضیحات فاکتور',
  sendInWhatsapp: 'ارسال با واتس‌اپ',
  copyLinkAndDownloadPDF: 'کپی لینک و دانلود PDF',
  sendBySMS: 'ارسال با پیامک',
  downloadPdfFile: 'دانلود فایل PDF',
  textCopySuccessfully: 'متن با موفقیت کپی شد',
  linkCopySuccessfully: 'لینک با موفقیت کپی شد',
  enterSmsText: 'متن پیامک را وارد کنید',
  logo: 'لوگو',
  preinvoiceDate: 'تاریخ پیش‌فاکتور',
  invoiceDate: 'تاریخ فاکتور',
  seller: 'فروشنده',
  buyer: 'خریدار',
  productNameAndCode: 'نام و کد محصول',
  discountPrice: 'مبلغ تخفیف',
  totalAmountAfterDiscount: 'مبلغ کل پس از تخفیف',
  total: 'مجموع',
  stampAndSignature: 'مهر و امضا',
  backgroundImage: 'تصویر پس‌زمینه',
  invoiceSetting: 'تنظیمات فاکتور',
  convertToFactorText: 'آیااز تبدیل پیش‌فاکتور {item} به فاکتور مطمئن هستید؟',
  convertToInvoiceText:
    'تبدیل پیش‌فاکتور به فاکتور به معنی پرداخت مبلغ آن توسط مشتری است.',
  preinvoiceConvertToInvoiceSuccessfully:
    'پیش‌فاکتور باموفقیت به فاکتور تبدیل شد.',
  title: 'عنوان',
  dataIsIncorrect: 'اطلاعات وارد شده صحیح نمی‌باشد',
  onlyPngFilesAreAllowed: 'فایل با فرمت png انتخاب کنید.',
  sendLink: 'لینک ارسال شود',
  fileToBeUploaded: 'فایل بارگزاری شود',
  performanceEvaluation: 'ارزیابی عملکرد',
  savePerformanceEvaluation: 'ثبت ارزیابی عملکرد',
  saveEvaluation: 'ثبت ارزیابی',
  performanceEvaluationReport: 'گزارش ارزیابی عملکرد',
  seccode: 'seccode',
  secretCode: 'secret code',
  signInNavatel: `ورود به ${companyName}`,
  username: 'نام کاربری',
  password: 'رمزعبور',
  rememberMe: 'مرا به خاطر بسپار',
  forgetPassword: 'فراموشی رمز عبور',
  login: 'ورود',
  invalidUsernameOrPassword: 'نام کاربری یا رمز عبور اشتباه است.',
  enterTheCerificationCode: 'ورود کد تایید',
  enterTheCodeSentToNavatelNumberBelow:
    'کدفرستاده شده به نواتل شماره <span>{number}</span> را در زیر وارد کنید.',
  resendAfter: 'ارسال دوباره بعد از:',
  resendCode: 'ارسال دوباره کد',
  didntGetTheCode: 'کد را دریافت نکرده‌اید؟',
  confirmDeletionOfRecords: 'تأیید حذف رکوردها',
  otpHasBeenSentToTheAdminToPerformThisOperation:
    'برای انجام این عملیات، کد تأیید به ادمین ارسال شد. لطفاً کد دریافتی را وارد کنید.',
  byConfirmingThisCodeTheConversationRecordsInTheSelectedRangeWillBePermanentlyDeleted:
    'با تأیید این کد، رکوردهای مکالمات در بازه انتخاب‌شده به‌صورت دائمی حذف خواهند شد.',
  forgotPassword: 'رمزعبور خود را فراموش کرده‌اید؟',
  forgotPasswordGuide: `لطفا شماره ${companyName} خود را در فیلد زیر وارد کنید. ما یک لینک بازیابی رمز عبور به ${companyName} شما ارسال خواهیم کرد.`,
  numberInNavatel: `شماره تلفن در اپلیکیشن ${companyName}`,
  enterYourNavatel: `شماره ${companyName} خود را وارد کنید`,
  backToLogin: 'بازگشت به خانه',
  notFoundNumber: 'شماره مورد نظر یافت نشد',
  linkSendSuccessfully: 'لینک با موفقیت برای شما ارسال شد',
  resetPassword: 'بازیابی رمزعبور',
  resetPasswordGuide:
    'رمزعبور جدید خود را وارد کنید تا بتوانید به حساب‌تان دسترسی پیدا کنید.',
  enterYourNewPassword: 'رمز عبور جدید خود را وارد نمایید',
  confirmPassword: 'تکرار رمزعبور',
  updatePasswordSuccessfully: 'رمزعبور شما با موفقیت به‌روزرسانی شد.',
  uploadFile: 'بارگذاری فایل',
  recordingName: 'نام فایل صوتی',
  play: 'پخش',
  uploadRecordingGuide:
    'حجم فایل شما نباید بیشتر از 5 مگابایت باشد.فرمت فایل باید mp3 یا wav باشد.',
  fileIsRequired: 'انتخاب فایل اجباری است.',
  fileSizeShouldBeLessThan: 'حجم فایل باید کمتر از {size} باشد.',
  recordingUploadSuccessfully: 'فایل با موفقیت بارگذاری شد.',
  deleteRecording: 'حذف فایل صوتی',
  deleteRecordingText: 'آیا از حذف فایل صوتی {item} مطمئن هستید؟',
  recordingDeleteSuccessfully: 'فایل صوتی با موفقیت حذف شد.',
  recording: 'فایل صوتی',
  fileSizeWarning:
    'حجم فایل شما نباید بیشتر از 5 مگابایت باشد.فرمت فایل باید mp3 یا wav باشد.',
  enterSearchKey: 'جستجوی کلمه کلیدی',
  newUser: 'شخص جدید',
  chooseStateFirst: 'ابتدا استان را انتخاب کنید',
  contactInformation: 'اطلاعات مخاطب',
  outOfToken:
    'تعدادتوکن های شما به اتمام رسیده است. لطفا مجددا پنل خود را شارژ کنید.',
  dataInsertSuccessfully: 'اطلاعات با موفقیت ثبت شد',
  dataUpdateSuccessfully: 'اطلاعات با موفقیت ویرایش شد',
  sureToCall: 'برقراری تماس',
  sureToCallText: 'آیا از برقراری تماس با  {item} مطمئن هستید؟',
  acceptCall: 'بله، برقراری تماس',
  peopleGuide:
    'راهنما با کلیک برروی افزودن شخص جدید، امکان تعریف پروفایل شخص وجود دارد.',
  createDate: 'تاریخ ایجاد',
  datePeriod: 'دوره تاریخ',
  percentageOfTotal: 'درصد از کل',
  selectCreateDate: 'انتخاب تاریخ ایجاد',
  row: 'ردیف',
  return: 'بازگشت',
  fieldsAreOptional: 'ثبت اطلاعات زیر اختیاری است.',
  editCompanyInformation: 'ویرایش شرکت',
  companyInformation: 'اطلاعات شرکت',
  companiesGuide:
    'راهنما با کلیک برروی افزودن شرکت جدید، امکان تعریف پروفایل شرکت وجود دارد.',
  website: 'وب‌سایت',
  faxNumber: 'شماره فکس',
  headOfFaxNumber: 'سر شماره فکس',
  selectHeadOfFaxNumber: 'انتخاب سر شماره فکس',
  creatHeadOfFaxNumber: 'ایجاد سر شماره فکس',
  editHeadOfFaxNumber: 'ویرایش سر شماره فکس',
  agentFullname: 'نام‌ و نام‌خانوادگی نماینده‌شرکت',
  agentName: 'نام‌ نماینده‌شرکت',
  agentFamily: 'نام‌خانوادگی نماینده‌شرکت',
  personInformation: 'اطلاعات شخص',
  mainInformation: 'اطلاعات اصلی',
  ContactInformation: 'اطلاعات ارتباطی',
  profileInformation: 'اطلاعات پروفایل',
  personalInformation: 'اطلاعات شخصی',
  agentInformation: 'اطلاعات نماینده',
  mainPhoneNumber: 'شماره تماس اصلی',
  subscribeInformation: 'اطلاعات اشتراک',
  inputMedia: 'رسانه ورودی',
  contactStatus: 'وضعیت مخاطب',
  leadStatus: 'وضعیت سرنخ',
  buyingChances: 'احتمال خرید',
  estimatedPurchaseAmount: 'پیش بینی مبلغ خرید',
  resultOfLastConnection: 'نتیجه آخرین ارتباط',
  dateOfLastConnection: 'تاریخ آخرین ارتباط',
  AddDateOfLastConnection: 'افزودن تاریخ آخرین ارتباط',
  lastConnection: 'آخرین ارتباط',
  followUpOperator: 'کارشناس پیگیری',
  acceptEdit: 'تایید ویرایش',
  nationalCode: 'کد ملی',
  companyName: 'نام شرکت',
  businessName: 'نام کسب و کار',
  businessInformation: 'اطلاعات کسب و کار',
  companyNationalId: 'شناسه ملی',
  major: 'حوزه فعالیت',
  ecoCode: 'کد اقتصادی',
  uniqueCode: 'کد یکتا',
  myCompanyNumber: `شماره ${companyName}`,
  whatsappNumber: 'شماره واتس‌اپ',
  telegramNumber: 'شماره تلگرام',
  instagram: 'اینستاگرام',
  likedin: 'لینکدین',
  landlinePhone: 'تلفن ثابت',
  profileCreationDate: 'تاریخ ایجاد پروفایل',
  gender: 'جنسیت',
  birthday: 'روز تولد',
  state: 'استان',
  city: 'شهر',
  address: 'آدرس',
  postalCode: 'کد پستی',
  activities: 'فعالیت‌ها',
  interactions: 'تعاملات',
  task: 'وظیفه',
  responsible: 'انجام‌دهنده',
  responsiblePlaceholder: 'کارشناس پیگیری مخاطب (پیش‌فرض)',
  creatTask: 'ایجاد وظیفه',
  taskTitle: 'عنوان وظیفه',
  taskType: 'نوع وظیفه',
  doneDate: 'تاریخ انجام',
  deadline: 'مهلت انجام',
  setDeadline: 'موعد انجام را تنظیم کنید',
  inConnectionWith: 'در ارتباط با',
  timeRemember: 'زمان یادآوری',
  telegram: 'تلگرام',
  sms: 'پیامک',
  mobileNumber: 'شماره موبایل',
  sentSmsList: 'صفحه پیامک‌ها',
  selectOriginNumber: 'انتخاب شماره مبدا',
  selectDestinationNumber: 'انتخاب شماره مقصد',
  smsText: 'متن پیامک',
  smsSubject: 'موضوع پیامک',
  smsType: 'نوع پیامک',
  enterYourText: 'متن خود را وارد کنید',
  avatar: 'عکس پروفایل',
  selectYourFile: 'فایل را انتخاب کنید',
  selectYourFilePngFormat: 'فایل را انتخاب کنید (فرمت: PNG)',
  addContact: 'افزودن مخاطب',
  deleteContact: 'حذف مخاطب',
  contactNumberSearch: 'جستجوی شماره مخاطب',
  subjectOrSmsTextSearch: 'جستجوی موضوع یا متن پیامک',
  deleteContactText: 'آیا از حذف مخاطب {item} اطمینان دارید؟',
  contactDeleteSuccessfully: 'مخاطب با موفقیت حذف شد.',
  contactInsertSuccessfully: 'مخاطب با موفقیت افزوده شد.',
  contactUpdateSuccessfully: 'مخاطب با موفقیت ویرایش شد',
  allCalls: 'همه تماس‌ها',
  missedCall: 'تماس از دست‌رفته',
  missed: 'از دست‌رفته',
  nextFollowUpDate: 'تاریخ پیگیری بعدی',
  reminder: 'یادآوری',
  reminderTime: 'انتخاب تاریخ یادآوری',
  noReminder: 'بدون یادآوری',
  noType: 'بدون نوع',
  noAssignee: 'بدون انجام دهنده',
  minutesAgo: '{item} دقیقه قبل',
  hoursAgo: '{item} ساعت قبل',
  daysAgo: '{item} روز قبل',
  atFollowUp: 'در زمان پیگیری',
  reason: 'دلیل',
  reasonsForCalling: 'دلایل تماس',
  addCallReason: 'ثبت دلیل تماس',
  callReason: 'دلیل تماس',
  callId: 'شناسه تماس',
  callReasonInsertSuccessfully: 'دلیل تماس با موفقیت ثبت شد',
  callToLanding: 'تماس با شماره ثابت',
  callToMain: 'تماس با شماره اصلی',
  jobPosition: 'سمت',
  note: 'یادداشت',
  submitNote: 'ثبت یادداشت',
  insertNote: 'افزودن یادداشت',
  createNote: 'ایجاد یادداشت',
  noteTitle: 'عنوان یادداشت',
  noteText: 'متن یادداشت',
  editNote: 'ویرایش یادداشت',
  enterNoteText: 'متن یادداشت را وارد کنید!',
  identityDocuments: 'مدارک هویتی',
  upload: 'بارگذاری',
  uploadIdentityDocuments: 'بارگذاری مدارک هویتی',
  editIdentityDocuments: 'ویرایش مدارک هویتی',
  uploadAttachments: 'بارگذاری پیوست',
  editAttachments: 'ویرایش پیوست',
  documentTitle: 'نام مدرک',
  documentFile: 'فایل مدرک',
  attachment: 'پیوست‌',
  attachments: 'پیوست‌ها',
  deleteFile: 'حذف فایل',
  deleteFileText: 'آیا از حذف فایل {item} مطمئن هستید؟',
  fileDeleteSuccessfully: 'فایل با موفقیت حذف شد.',
  fileInserSuccessfully: 'فایل با موفقیت افزوده شد.',
  fileUpdateSuccessfully: 'اطلاعات فایل با موفقیت به‌روزرسانی شد.',
  noteDeleteSuccessfully: 'یادداشت با موفقیت حذف شد.',
  noteInserSuccessfully: 'یادداشت با موفقیت افزوده شد.',
  noteUpdateSuccessfully: 'یادداشت با موفقیت ویرایش شد.',
  calling: 'در حال تماس',
  rial: 'ریال',
  excel: 'excel',
  downloadExcelFile: 'دانلود فایل Excel',
  exportWithFilters: 'خروجی بر اساس فیلترهای زیر',
  advanceFilter: 'جستجوی پیشرفته',
  doDelete: 'پاک کردن ',
  clear: 'پاک کردن',
  clearAll: 'پاک کردن همه',
  past: 'گذشته',
  yesterday: 'دیروز',
  today: 'امروز',
  day: 'روز',
  tomorrow: 'فردا',
  future: 'آینده',
  sendMessage: 'پیام ارسالی',
  reciveMessage: 'پیام دریافتی',
  comments: 'نظرها',
  addComment: 'نظردهی',
  closeComment: 'بستن نظردهی',
  onlineChat: 'چت آنلاین',
  typing: 'در حال نوشتن...',
  recordingVoice: 'در حال ضبط صدا...',
  sendingFile: 'در حال ارسال فایل...',
  picture: 'تصویر',
  mapLocation: 'موقعیت مکانی',
  selectYourLocation: 'موقعیت خود را انتخاب کنید',
  audioFile: 'فایل صوتی',
  videoRecord: 'ضبط ویدئو',
  video: 'ویدئو',
  camera: 'دوربین',
  downloadFailed: 'بارگیری با خطا مواجه شد',
  queueGuide: 'راهنما: در این قسمت امکان ایجاد صف (داخلی ها) وجود دارد.',
  insertQueue: 'ایجاد صف',
  extention: 'داخلی {text}',
  insertQueueCallcenter: 'ایجاد صف مرکز تلفن',
  selectStrategy: 'انتخاب استراتژی زنگ خوردن',
  callAllOperators: 'همه کاربران زنگ بخورد',
  ringAll: 'همه کاربران زنگ بخورد',
  roundRobinAlgorithm: 'تصادفی با الگوریتم راندرابین',
  roundRobin: 'تصادفی با الگوریتم راندرابین',
  orderWithMinCall: 'کاربر با حداقل تعداد مکالمه',
  operatorWithMinTalkTime: 'کاربر با حداقل زمان مکالمه',
  agentWithLeastTalkTime: 'کاربر با حداقل زمان مکالمه',
  orderOfOperators: 'بر اساس ترتیب کاربر',
  topDown: 'بر اساس ترتیب کاربر',
  selectWaitingVoice: 'انتخاب آوای انتظار در صف',
  waitingVoice: 'آوای انتظار در صف',
  maxWaitingTime: 'حداکثر زمان انتظار',
  maxWaitingTimeAnyOperatorAvailable:
    'حداکثر زمان انتظار وقتی هیچ کاربری در دسترس نیست',
  maxWaitingTimeNoOperatorAvailable:
    'حداکثر زمان انتظار وقتی کاربر در دسترس نیست',
  actionForExpiredQueueTime:
    'درصورت به پایان رسیدن زمان انتظار در صف، عملیات را انتخاب کنید.',
  activateCallRecording: 'فعال سازی ضبط مکالمه',
  expiredQueueTime: 'در صورت به پایان رسیدن زمان انتظار در صف',
  activatePollingOfIncomingCalls: 'فعال سازی نظرسنجی تماس‌های ورودی',
  hideCallerIdOfIncomingCall: 'پنهانسازی کالر آیدی تماس‌های ورودی برای صف',
  callerId: 'کالر آیدی',
  numberOfPeopleWaiting: 'اعلام تعداد نفرات در صف',
  waitingTimeInQueue: 'اعلام مدت زمان انتظار در صف',
  leavingQueueAndGoBack: 'امکان خروج از صف و بازگشت به مرحله قبل',
  endConversation: 'پایان گفتگو',
  areYouSureThisConversationIsOver: 'آیا از پایان این گفتگو مطمئن هستید؟',
  selectEndReason: 'انتخاب علت پایان',
  leaveKey: 'کلید خروج از صف',
  noQueue: 'هنوز صفی ثبت نشده.',
  leaveAction: 'در صورت خروج از صف، عملیات را انتخاب کنید.',
  active: 'فعال',
  deactive: 'غیر فعال',
  all: 'همه',
  queueInsertSuccessfully: 'صف با موفقیت افزوده شد.',
  queueUpdateSuccessfully: 'صف با موفقیت ویرایش شد.',
  deleteQueue: 'حذف صف',
  deleteQueueText: 'آیا از حذف صف {item} مطمئن هستید؟',
  queueDeleteSuccessfully: 'صف با موفقیت حذف شد.',
  addOperatorToQueue: 'افزودن کاربر به مرکز تماس',
  addOperatorToQueueTitle: 'برای افزودن کاربر روی تیک سبز رنگ کلیک کنید',
  addOperatorToQueueText:
    'برای اعمال ترتیب زنگ خوردن کاربران پس از تنظیم "استراتژی زنگ خوردن" مرکز تماس به "بر اساس ترتیب کاربر" ردیف شماره ها را جابجا کنید ',
  thisCallNotForYou: 'این تماس متعلق به شما نیست',
  ivrGuide:
    'راهنما در این قسمت امکان اضافه کردن منوی IVR برای انتخاب داخلی ها و بارگذاری صوت وجود دارد.',
  insertIvr: 'ایجاد منوی IVR',
  internalId: 'شناسه داخلی',
  minutesSeconds: '(ثانیه/دقیقه)',
  selectRecordingFile: 'انتخاب فایل صوتی',
  durationConnectionOperator: 'مدت زمان اتصال به کاربر',
  durationConnectionPreviousOperator:
    'مدتذخیره ماندن اتصال به کاربر قبلی به دقیقه',
  connectCallToPreviousOperator: 'اتصال تماس به کاربر قبلی',
  selectActionIvrFinished: 'انتخاب عملکرد بعد از به پایان رسیدن منوی IVR',
  addExtention: 'ثبت داخلی',
  addVipExtention: 'ثبت داخلی اختصاصی',
  ivrInsertSuccessfully: 'IVR با موفقیت افزوده شد.',
  ivrUpdateSuccessfully: 'IVR با موفقیت ویرایش شد.',
  deleteIvr: 'حذف آی‌وی‌آر',
  deleteIvrText: 'آیا از حذف آی‌وی‌آر {item} مطمئن هستید؟',
  ivrDeleteSuccessfully: 'IVR با موفقیت حذف شد.',
  callDestinationGuide:
    'راهنما برای دریافت تماس ها، عمل مورد نظر را انتخاب نمایید.',
  channelName: 'نام کانال',
  channel: 'کانال',
  wallet: 'موجودی',
  numberOfCalls: 'تعداد کل تماس‌ها‌',
  numberOfCall: 'تعداد تماس',
  answeredIncomingCall: 'تماس‌ ورودی پاسخ داده شده',
  answeredOutgoingCall: 'تماس‌ خروجی پاسخ داده شده',
  unansweredIncomingCall: 'تعداد تماس‌های ورودی بی‌پاسخ',
  unansweredOutgoingCall: 'تعداد تماس‌های خروجی بی‌پاسخ',
  timeOfOutgoingCalls: 'دقایق مکالمه تماس‌های خروجی',
  timeOfIncomingCalls: 'دقایق مکالمه تماس‌های ورودی',
  averageWaitingTime: 'میانگین زمان انتظار',
  minWaitingTime: 'کمترین زمان انتظار',
  averageTalkTime: 'میانگین زمان مکالمه',
  maxTalkTime: 'بیشترین زمان مکالمه',
  minTalkTime: 'کمترین زمان مکالمه',
  averageIncomingTalkTime: 'میانگین زمان مکالمه ورودی',
  averageOutTalkTime: 'میانگین زمان مکالمه خروجی',
  costOfCalls: 'هزینه تماس‌ها',
  asr: 'سطح سرویس ارائه خدمت',
  cloudMemory: 'فضای ابری',
  totalMemory: 'فضای کل',
  remainingMemory: 'فضای باقی‌مانده',
  usedMemory: 'فضای مصرف شده',
  mb: 'مگابایت',
  version: 'ورژن',
  totalIncomingCall: 'کل تماس  ورودی',
  totalOutgoingCall: 'کل تماس  خروجی',
  operatorAvailableToCall: ' کاربران حاضر برای تماس',
  totalCustomersInIvr: ' مشتریان در IVR',
  numberOfIncomingCallsAnswered: ' تماس‌ ورودی پاسخ داده شده',
  numberOfOutgoingCallsAnswered: ' تماس‌ خروجی پاسخ داده شده',
  numberOfSimultaneousCalls: ' همزمانی تماس',
  inUse: 'در حال استفاده',
  free: 'آزاد',
  totalCustomersInQueue: ' مشتریان در صف',
  numberOfIncomingCallsDropped: ' تماس‌ ورودی قطع شده (توسط مشتری)',
  byCustomer: '(توسط مشتری)',
  numberOfOutgoingUnansweredCalls: ' تماس‌ بی پاسخ خروجی',
  theNumberOfOperatorsInConversation: ' کاربر در حال مکالمه',
  pollScore: 'امتیاز نظرسنجی',
  numberOfIncomingUnansweredCalls: ' تماس‌ بی پاسخ ورودی',
  numberOfIncomingCalls: ' تماس های ورودی',
  numberOfOperatorsToAnswer: ' کاربر برای پاسخگویی',
  numberOfOperatorsInIncomingConversation: ' کاربر در حال مکالمه ورودی',
  numberOfSimultaneousIncomingCalls: ' همزمانی تماس ورودی',
  AverageIncomingTalkTime: 'میانگین زمان مکالمه ورودی',
  fullScreen: 'تمام صفحه',
  origin: 'مبدا',
  destination: 'مقصد',
  waitingTimePlaceholder:
    'بیشترین زمان انتظار زمانی که همه کاربران مشغول مکالمه باشند',
  callDuration: 'مدت زمان مکالمه',
  whisper: 'نجوا',
  callControl: 'کنترل تماس',
  enterConversation: 'ورود به مکالمه',
  waitingForCall: 'در انتظار تماس',
  outgoingCall: 'تماس خروجی',
  incomingCall: 'تماس ورودی',
  inOutgoingCall: 'در حال تماس خروجی',
  userName: 'نام کاربر',
  userNumber: 'شماره کاربر',
  userStatus: 'وضعیت کاربر',
  statusDuration: 'مدت زمان وضعیت',
  changeOperatorStatus: 'آیا نسبت به تغییر وضعیت اپراتور مطمئن هستید؟',
  rest: 'استراحت',
  available: 'در دسترس',
  launch: 'ناهار',
  arrest: 'مرخصی',
  holiday: 'تعطیلات',
  inMeeting: 'در جلسه',
  faxInsertGuide:
    'راهنما برای ایجاد و ارسال فکس، با کلیک برروی ایجاد فکس،  آدرس ایمیل خود را وارد نمایید.',
  identerUniqeNumber: 'شناسه: یک عدد غیر تکراری وارد نمایید.',
  enterYourEmail: 'ایمیل خود را وارد نمایید.',
  faxInsertSuccessfully: 'فکس با موفقیت افزوده شد.',
  faxUpdateSuccessfully: 'فکس با موفقیت ویرایش شد.',
  deleteFaxFile: 'حذف فایل فکس',
  deleteFaxFileText: 'آیا از حذف فایل فکس با شناسه  {item} مطمئن هستید؟',
  deleteFax: 'حذف فکس',
  deleteFaxText: 'آیا از حذف فکس  {item} مطمئن هستید؟',
  faxDeleteSuccessfully: 'فکس با موفقیت حذف شد',
  emailAddress: 'آدرس ایمیل',
  selectOrigin: 'انتخاب مبدا',
  destinationNumber: 'شماره مقصد',
  destinationInternalNumber: 'شماره داخلی مقصد(اختیاری)',
  tryToSend: 'تعداد تلاش برای ارسال',
  selectPdf: 'انتخاب فایل pdf',
  selectFile: 'فایل را انتخاب کنید',
  dragAndDrop: 'فایل خود را بکشید و رها کنید',
  or: 'یا',
  faxSendSuccessfully: 'فکس با موفقیت ارسال شد',
  faxSenderNumber: 'شماره ارسال کننده فکس',
  receivedDate: 'تاریخ دریافت',
  receivedTime: 'ساعت دریافت',
  status: 'وضعیت',
  recieveStatus: 'وضعیت دریافت',
  success: 'موفق',
  successCount: 'تعداد موفق',
  failed: 'ناموفق',
  failedCount: 'تعداد ناموفق',
  totalCreatedAmount: 'مجموع ارزش ایجاد شده',
  totalSuccessAmount: 'مجموع ارزش موفق',
  totalFailedAmount: 'مجموع ارزش ناموفق',
  theCodeEnteredIsInvalid: 'کد وارد شده نامعتبر است',
  fileUnavailable: 'فایل در دسترس نیست.',
  faxFileDeleteSuccessfully: 'فایل فکس با موفقیت حذف شد',
  next: 'بعدی',
  previous: 'قبلی',
  faxRecieverNumber: 'شماره دریافت کننده فکس',
  sendDate: 'تاریخ ارسال',
  departmentguid:
    'راهنما با استفاده از قابلیت "ایجاد دپارتمان"، می\u200Cتوانید تیم\u200Cهایی با تخصص\u200Cهای متفاوت بسازید و برای هرکدام اپراتور مخصوص اختصاص دهید.',
  createdepartment: 'افزودن دپارتمان',
  queueDescription: 'توضیحات',
  deletedepartment: 'حذف دپارتمان',
  editdepartment: 'ویرایش دپارتمان',
  willdeletedepartment: 'آیا از حذف دپارتمان {item} مطمئن هستید؟',
  addAgentToQueModalTitle: 'اپراتورها',
  clickToAddAgent: 'برای افزودن اپراتور روی تیک سبز رنگ کلیک کنید',
  noAgentForSelectedOperator: 'اپراتوری برای این دپارتمان موجود نیست',
  changeAgentsOfDepartment: 'اپراتورهای دپارتمان با موفقیت ویرایش شد.',
  websitelist: 'لیست وبسایت‌ها',
  websitelistguid:
    'راهنما شما می‌توانید در اینجا ضمن مشاهده لیست سایت‌ها، تکه کد منحصر به فرد هر سایت را دریافت کنید.',
  addwebsite: 'افزودن وب‌سایت',
  enterurlhereexample: 'لطفا URL وب‌سایت را وارد کنید.',
  example: 'مثال: {item}',
  websitename: 'عنوان وب‌سایت',
  enterSiteName: 'نام دلخواه خود را وارد کنید',
  websiteaddress: 'آدرس وب‌سایت',
  selectWebsite: 'انتخاب وب‌سایت',
  activation: 'فعال‌سازی',
  guide: 'راهنما',
  websiteInsertSuccessfully: 'وبسایت با موفقیت افزوده شد.',
  websiteUpadatedSuccessfully: 'وبسایت با موفقیت بروزرسانی شد.',
  getcode: 'دریافت تکه کد',
  addcodetoheader: 'لطفا تکه کد را در Head وب‌سایت سایت اضافه کنید.',
  setwebsitecode: 'نصب تکه کد در وبسایت',
  snippetcode: 'تکه کد',
  copyCode: 'کپی تکه کد',
  copy: 'کپی',
  close: 'بستن',
  websitecodeguide:
    'راهنما لطفا تکه کد ایجاد شده را در Header سایت خود قرار دهید.',
  textcopied: 'متن کپی شد.',
  operatorRegister: 'ثبت شماره اپراتور',
  operatorNubmber: 'شماره اپراتور',
  operatorRegisterModalGuide: `یک شماره که در پیام رسان ${companyName} اکانت دارد را وارد کرده و در مرحله بعد، آن را بوسیله کد تاییدی که پیام رسان ${companyName} ارسال می‌شود، تایید کنید.`,
  operatorRegisterGuide: `راهنما: شماره‌ای که دارای اپلیکیشن ${companyName} می‌باشد را اضافه کرده و با استفاده از کلید ذخیره آن را فعال کنید.`,
  operatorRegisterPlaceHolder: 'شماره موبایل را با 98 وارد کنید.',
  operatorRegisterButtonTitle: 'افزودن شماره اپراتور',
  confirmNumber: 'تایید شماره',
  verifyCode: 'کد تایید',
  operationDone: 'عملیات مورد نظر با موفقیت انجام شد',
  webChatOperatorsNumbers: 'شماره‌ اپراتورهای وب چت',
  numberDeleteModalTitle: 'حذف شماره',
  numberDeleteModalText: 'آیا از حذف شماره  {item} مطمئن هستید؟',
  manageOperatorGuid:
    'راهنما برای فعالسازی سطح دسترسی و ایجاد یوزر برای ایجنت‌ این قسمت را کامل نمایید.',
  addUserOperator: 'تعریف اپراتور',
  registerOperator: 'ثبت شماره اپراتور',
  selectNumbers: 'شماره های مورد نظر را انتخاب کنید.',
  dashboardwebchat: 'پیشخوان',
  dashboardwebchatguidtext: 'پیام‌های ارسالی و دریافتی بر حساب اپراتور',
  selectedOperator: 'اپراتورهای انتخاب شده',
  operatorAcceessLevel: 'سطح دسترسی اپراتور',
  manageRoleGuid: 'راهنما امکان تعیین سطح دسترسی برای نقش اپراتور وجود دارد.',
  whatoperatoraccesses:
    'اپراتورها چه دسترسی هایی در سامانه گفتگوی آنلاین شما داشته باشند؟',
  enterRoleName: 'نام نقش را وارد کنید.',
  addOperator: 'افزودن اپراتور',
  editOperator: 'ویرایش اپراتور',
  others: 'دیگر',
  roleNameDuplicate: 'نام وارد شده تکراری است.',
  fromDate: 'از تاریخ',
  toDate: 'تا تاریخ',
  doSelect: 'انتخاب کنید',
  phoneNumber: 'شماره تماس',
  navatelPhoneNumber: 'شماره نواتل',
  search: 'جستجو',
  recentSearches: 'جستجوهای اخیر',
  recentResults: 'نتایج اخیر',
  audience: 'مخاطب',
  taskCode: 'کد وظیفه',
  productCode: 'کد محصول',
  sourceChannelId: 'شناسه درگاه ارتباطی',
  doSearch: 'جستجو کنید',
  noRecord: 'رکوردی یافت نشد',
  loadingTableText: 'لطفا صبر کنید',
  opratorNumber: 'شماره کاربر',
  enterNumber: 'شماره را وارد نمایید',
  save: 'ذخیره',
  editSubmit: 'ثبت ویرایش',
  withdrawal: 'انصراف',
  no: 'خیر',
  ok: 'باشه',
  submitOtp: 'ارسال کد تایید',
  confirm: 'تایید',
  continue: 'ادامه',
  canNotConnectToService: 'خطا در اتصال به سرویس',
  canNotConnectToServer: 'خطا در اتصال به سرور',
  actionDoSuccessfully: 'عملیات مورد نظر با موفقیت انجام شد.',
  commentSuccessfullySubmited: 'نظر با موفقیت ثبت شد.',
  commentSuccessfullyEdited: 'نظر با موفقیت ویرایش شد.',
  deleteItemText: 'برای حذف  {item} اطمینان دارید؟',
  deleteItem: 'حذف',
  edit: 'ویرایش',
  usersList: 'لیست کاربران',
  fileUpload: 'آپلود فایل',
  view: 'مشاهده',
  pause: 'توقف',
  copyLink: 'کپی لینک',
  enteringMeeting: 'ورود به جلسه',
  preview: 'پیش‌نمایش',
  information: 'اطلاعات',
  fromdate: 'از تاریخ',
  todate: 'تا تاریخ',
  phonenumber: 'شماره تلفن',
  norecord: 'رکوردی یافت نشد',
  noReports: 'گزارش یافت نشد!',
  loadingtableText: 'لطفا صبر کنید',
  callType: 'نوع تماس',
  queueName: 'نام صف',
  operatorId: 'شناسه کاربر',
  operatorType: 'نوع کاربر',
  ClickOnRegistrationOfOperatorNumber:
    'راهنما برای تعریف کاربر مرکز تماس خود، بر روی ثبت شماره کاربر کلیک کرده و نوع کاربر را انتخاب نمایید.',
  registrationOfOperatorNumber: 'ثبت شماره کاربر',
  registrationOfOperator: 'ثبت کاربر',
  OperatorType: 'کاربر',
  operator: 'کاربر',
  callcenterOperator: 'کاربر مرکز تماس',
  family: 'نام خانوادگی',
  number: 'شماره',
  fullname: 'نام و نام خانوادگی',
  enterFullname: 'نام و نام خانوادگی را وارد کنید',
  navatelUser: `کاربر ${companyName}`,
  navatelUsersusernamePassword: `کاربران ${companyName} (یوزرنیم پسورد)`,
  ipPhone: 'آی‌پی‌فون',
  userRegistrationWithMobileNumber: 'ثبت کاربر با شماره موبایل',
  userRegistrationWithUsernameAndPassword: 'ثبت کاربر با نام کاربری و رمز عبور',
  ipPhoneUserRegistration: 'ثبت کاربر آی‌پی‌فون',
  withMobileNumber: 'با شماره موبایل',
  mobilenumber: 'شماره موبایل',
  withUsernameAndPassword: 'با نام کاربری و رمز عبور',
  withIpPhone: 'با آی‌پی‌فون',
  enterYourNumberWith98: 'شماره موبایل خود را وارد با 98 نمایید',
  usernameenterYourNumberWith98:
    'نامکاربری (شماره موبایل خود را وارد با 98 نمایید)',
  englishLowercaseLettersAndNumbers:
    'رمز باید شامل حروف کوچک انگلیسی و عدد باشد',
  thePasswordMustContainLowerCaseEnglishLettersAndNumbers:
    'رمزعبور شامل حروف کوچک انگلیسی و عدد باشد',
  enterTheVerificationCode: 'کد تایید را وارد کنید',
  navatelNumberConfirmation: `تایید شماره ${companyName}`,
  confirmationAndFinalRegistrationOfNavatelNumberEnterTheConfirmationCodeSentToTheDesiredNumberInNavatelMessenger: ` تایید و ثبت نهایی شماره ${companyName} - کد تاییدی که برای شماره مورد نظر شما در پیام رسان ${companyName} ارسال شده است را وارد کنید `,
  nnavanumberInsertSuccessfully: `اطلاعات کاربر ${companyName} با موفقیت ثبت شد`,
  nnavanumberDeleteSuccessfully: `اطلاعات کاربر ${companyName} با موفقیت حذف شد`,
  nnavanumberUpdateSuccessfully: `اطلاعات کاربر ${companyName} با موفقیت ویرایش شد`,
  navaaccountInsertSuccessfully: `اطلاعات کاربر ${companyName} با موفقیت ثبت شد`,
  navaaccountDeleteSuccessfully: `اطلاعات کاربر ${companyName} با موفقیت حذف شد`,
  accountInsertSuccessfully: 'اطلاعات کاربر آی‌پی‌فون با موفقیت ثبت شد',
  accountDeleteSuccessfully: 'اطلاعات کاربر آی‌پی‌فون با موفقیت حذف شد',
  deleteOperatorTitle: 'حذف کاربر',
  deleteOperatorText: 'کاربر حذف خواهد شد. اطمینان دارید؟',
  areYouSureYouWantToDeleteUser: 'آیااز حذف کاربر {item} مطمئن هستید؟',
  areYouSureYouWantToDeleteRole: 'آیااز حذف نقش "<b>{text}</b>" مطمئن هستید؟',
  yesDelete: 'بله، حذف',
  allOperators: 'همه کاربران',
  operators: '{text} کاربر',
  systemSettings: 'تنظیمات سامانه',
  onlineConversationTitle: 'عنوان باکس گفتگوی آنلاین:',
  onlineConversationTitlePlaceholder:
    'نام نمایش داده شده برای کاربران هنگام کلیک بر روی باکس گفتگو',
  welcomeMessage: 'پیام خوش آمدگویی',
  welcomeMessagePlaceholder:
    'متن پیشفرض نمایش داده شده هنگام باز کردن صفحه گفتگوی آنلاین',
  beginningMessage: 'پیام شروع',
  beginningMessagePlaceholder: 'متن خودکار ارسالی برای شروع گفتگو با مشتری',
  popupContent: 'متن پاپ‌آپ:',
  popupContentPlaceholder: 'متن پاپ‌آپ',
  popupTitle: 'عنوان پاپ‌آپ:',
  popupTitlePlaceholder: 'عنوان پاپ‌آپ',
  operatorResponseStrategy: 'استراتژی پاسخگویی کاربران',
  replacementonthesite: 'جایگشت در سایت:',
  leftMargin: 'فاصله از چپ:',
  rightMargin: 'فاصله از راست:',
  bottomMargin: 'فاصله از پایین:',
  choosePhoto: 'انتخاب تصویر:',
  onlineConversationLanguage: 'زبان گفتگوی آنلاین',
  chooseColor: 'انتخاب رنگ:',
  chooseColorPlaceHolder: 'انتخاب رنگ:',
  departmentText: 'متن پیش‌فرض انتخاب دپارتمان',
  submitSettings: ' ثبت تنظیمات ',
  deleteRoleText: 'آیا از حذف نقش {item} مطمئن هستید؟',
  baseInformation: 'اطلاعات پایه',
  templateAndColors: 'قالب و رنگ‌بندی',
  makeForm: 'ایجاد فرم',
  timeConditions: 'شرط‌های زمانی',
  learnBot: 'آموزش بات',
  modalTitle: 'عنوان مودال',
  statusIndicator: 'نشانگر وضعیت',
  enterStartMessage: 'پیام شروع را وارد کنید!',
  startTextHint:
    'اولین پیامی که به مخاطب از طرف سیستم به صورت خودکار ارسال می‌شود.',
  guideText: 'متن راهنما',
  enterWelcomeText: 'متن خوش‌آمدگویی را وارد کنید!',
  enterGuideText: 'متن راهنما را وارد کنید!',
  showQuestionsFirst: 'ابتدا سوالات متداول نمایش داده شود.',
  enteringPhonenumberIsRequired: 'ورود شماره تماس اجباری باشد.',
  uploadLogo: 'بارگذاری لوگو',
  uploadAvatar: 'بارگذاری آواتار',
  logoHint: 'ابعاد پیشنهادی: 20x20 پیکسل، فرمت PNG.',
  defaultLogo: 'لوگوهای پیش فرض',
  defaultAvatar: 'آواتارهای پیش فرض',
  showInWebsite: 'نمایش در وب‌سایت',
  onlyMainPage: 'فقط صفحه اصلی',
  allPages: 'همه صفحات',
  showInMobile: 'نمایش در موبایل',
  selectTheme: 'انتخاب تم رنگی',
  selectCustomTheme: 'انتخاب رنگ دلخواه',
  copyRightNavatel: 'طراحی و اجرا توسط نواتل',
  createFormAs: 'ایجاد فرم به صورت',
  integrate: 'یکپارچه',
  everyDepartment: 'هر دپارتمان',
  questionNumber: 'سوال متداول شماره {number}',
  answereNumber: 'پاسخ سوال متداول شماره {number}',
  addQuestion: 'افزودن سوال متداول',
  addQuestionDepartment: 'افزودن سوالات دپارتمان جدید',
  questionListUpdate: 'لیست سوال‌ها با موفقیت ویرایش شد',
  showPopup: 'پاپ‌آپ نمایش داده شود.',
  normalDays: 'روزهای عادی',
  specialDays: 'روزهای خاص',
  sunday: 'یک‌شنبه',
  monday: 'دوشنبه',
  tuesday: 'سه‌شنبه',
  wednesday: 'چهارشنبه',
  thursday: 'پنج‌شنبه',
  friday: 'جمعه',
  saturday: 'شنبه',
  workingDay: 'روز کاری',
  vacation: 'تعطیل',
  webchatInVacation: 'وضعیت وب‌چت در روزهای تعطیل',
  webchatInSpecial: 'وضعیت وب‌چت در روزهای خاص',
  offlineMessage: 'پیام آفلاین',
  sendSmartMessage: 'ارسال پیام هوشمند',
  sendToWhatsapp: 'ارسال پیام‌ها به واتسپ',
  hideChatBox: 'عدم نمایش چت‌باکس در ساعت غیرکاری',
  disableChat: 'غیرفعال کردن امکان چت',
  offlineMessageText:
    'مخاطب بعد از وارد کردن اطلاعات، پیامی مبتنی برپایان ساعت کاری دریافت می‌کند',
  enterMessage: 'پیام را وارد کنید',
  addSpecialDay: 'افزودن روز خاص',
  clickToAddSpecialDay: 'برای افزودن روزهای خاص روی دکمه زیر کلیک کنید.',
  crmNumbersTitle: 'تعریف شماره مجاز CRM',
  crmNumbersGuidNoNum:
    'درحال حاضر شماره‌ای افزوده نشده است. برای این کار از دکمه‌ی افزودن استفاده نمایید.',
  crmGuidNumbers:
    'راهنما: برای اتصال کاربران برای تنظیمات سی آر ام، شماره کاربر را وارد نمایید.',
  crmNumberAddButton: 'افزودن',
  crmNumberReturnButton: 'بازگشت',
  crmContactNumber: 'شماره تماس',
  crmAddModalText:
    'دراین بخش باید شماره با با پیش شماره ۹۸ و بدون صفر وارد نمایید.',
  crmTypeTitle: 'نوع CRM انتخابی:',
  crmUrl: 'آدرس URL :',
  crmUrlPlaceholder: 'url',
  crmSettingsTitle: 'ساختار CRM',
  crmSettingsGuide:
    'برای اتصال یه سی ار ام لطفا نوع سی ارام خود را انتخاب نمایید.',
  crmSettingDeleteWarning: 'آیا از حذف ساختار {item} مطمئن هستید؟',
  crmSettingDeleteTitle: 'حذف ساختار CRM',
  crmUsersTitle: 'لینک‌های اتصال به CRM',
  connectPhone: 'شماره تلفن جهت اتصال',
  apiKey: 'api key',
  serverNo: 'serverno',
  crmUserDeleteWarning: 'آیا از حذف سی‌آرام {item} مطمئن هستید؟',
  crmUserDeleteTitle: 'حذف سی‌آرام',
  crmSettingsDeleteError: 'حذف crm به درستی انجام نشد.',
  crmNoUrlDana: ' به جای کلمه ی domain، لطفا نام دامنه خود را وارد نمایید.',
  accessToTheMicrophoneIsNotPossible: 'دسترسی به میکروفون امکان پذیر نیست',
  domain: 'دامنه',
  url: 'url',
  crmLinksGuide:
    'راهنما برای اتصال نهایی، لینک های لازم را برحسب نوع سی آر ام تکمیل نمایید.',
  managingTheAccessLevelOfCallCenterOperators:
    'مدیریتسطح دسترسی کاربران مرکز تماس',
  helpToActivateTheRoleOfOperatorsSelectTheirNumberAndSpecifyTheRoleAsSoonAsTheRoleIsSelectedForTheUserTheUsernameAndPasswordWillBeSentToNavatel: `راهنما: برای فعالسازی نقش کاربرها، شماره کاربران را هنگام کلیک برروی افزودن انتخاب کرده و نقش را مشخص نمایید. به محض انتخاب نقش برای کاربر، نام کاربری و رمز عبور داخل ${companyName} ارسال میشود.`,
  reporter: 'گزارشگیر',
  adminReporter: 'گزارشگیر ادمین',
  AdminReporter: 'گزارشگیر ادمین',
  admin: 'ادمین',
  support: 'پشتیبانی',
  superAdmin: 'مدیر',
  SuperAdmin: 'مدیر',
  noAccess: 'بدون دسترسی',
  addUser: 'افزودن کاربر',
  editUser: 'ویرایش کاربر',
  removeTheNumberTitle: 'حذف شماره',
  removeTheNumberText: 'شماره حذف خواهد شد. اطمینان دارید؟',
  download: 'دانلود',
  subusersInsertSuccessfully: 'اطلاعات کاربر با موفقیت ثبت شد',
  subusersUpdateSuccessfully: 'اطلاعات کاربر با موفقیت ویرایش شد',
  subusersDeleteSuccessfully: 'اطلاعات کاربر با موفقیت حذف شد',
  selectTheDesiredNumbers: 'شماره های مورد نظر را انتخاب کنید',
  accessToAllCallCenterFacilities: 'دسترسی به همه امکانات مرکز تماس',
  accessToCallCenterMenus: 'دسترسی به منوهای مرکز تماس',
  accessToCallCenterSettings: 'دسترسی به تنظیمات مرکز تماس',
  fullAccessToReports: 'دسترسی کامل به گزارشات',
  fullAccess: 'دسترسی کامل',
  viewReports: 'مشاهده گزارشات',
  viewReport: 'مشاهده گزارش',
  abilityToSendTicketsAndFollowUp: 'امکان ارسال تیکت و پیگیری',
  clickOnTheIconOppositeToView: 'برای مشاهده روی آیکن روبرو کلیک کنید',
  defaultItem: 'از پیش تعیین شده',
  userItem: 'وارد شده توسط مشتری',
  managingTheRoleOfCallCenterOperators: 'مدیریت نقش کاربران مرکز تماس',
  helppleaseselectyourrolenameinlatin:
    'راهنما برای ایجاد نقش، لطفا نام نقش خود را انگلیسی انتخاب نمایید.',
  addRole: 'افزودن نقش',
  addANewRole: 'افزودن نقش جدید',
  editRole: 'ویرایش نقش',
  registerANewRole: 'ثبت نقش',
  enterTheRoleNameInEnglish: 'نام نقش را به انگلیسی وارد کنید',
  selectAll: 'انتخاب همه',
  cancel: 'لغو',
  cancelAll: 'لغو همه',
  feature: '{count} ویژگی',
  accesses: 'دسترسی ها',
  roleName: 'نام نقش',
  roleType: 'نوع نقش',
  deletePermissionsTitle: 'حذف نقش',
  deletePermissionsText: 'نقش حذف خواهد شد. اطمینان دارید؟',
  permissionsInsertSuccessfully: 'اطلاعات نقش با موفقیت ثبت شد',
  permissionsEditSuccessfully: 'اطلاعات نقش با موفقیت ویرایش شد',
  permissionsDeleteSuccessfully: 'اطلاعات نقش با موفقیت حذف شد',
  showDefaultRole: 'نمایش سطح دسترسی نقش پیشفرض',
  showRole: 'نمایش سطح دسترسی',
  subscriptionName: 'subscription name',
  yourNumberOfAuthorizedNumbersIsOver: 'تعدادشماره های مجاز شما تمام شده است',
  sendMessagesToOperators: 'ارسال پیام به کاربران',
  sendMessagesToNavatel: 'ارسال پیام به نواتل',
  setthelistofnumberstowhichyoucansendmessagesandsendyourmessage:
    'راهنما: از این بخش لیست کاربرانی که میتوانید به آن ها پیام ارسال نمایید را انتخاب کرده و پیام خود را ارسال نمایید.',
  youcanselectthelistofreceivednumbersusingthebluebutton:
    'بصورت پیش فرض پیام برای تمام شماره ها ارسال خواهد شد؛ با استفاده از دکمه ی آبی رنگ می توانید لیست شماره های دریافتی را انتخاب نمایید',
  text: 'متن',
  message: 'پیام',
  enterthedescription: 'توضیحات را وارد کنید!',
  messageRecipients: 'دریافت‌کننده‌های پیام',
  sendTheMessageTitle: 'ارسال پیام',
  areyousureyouwanttosendamessagefromthechannel:
    'آیااز ارسال پیام از کانال {item} مطمئن هستید؟',
  sendTheMessageText:
    'پیام شما به همه ی مخاطبانی که انتخاب کرده اید ارسال خواهد شد. اطمینان دارید؟',
  messageInsertSuccessfully: 'ارسال پیام با موفقیت انجام شد',
  subject: 'موضوع',
  add: 'افزودن',
  manageMessageRecipients: 'مدیریت دریافت کنندگان پیام',
  bydefaultallnumbersreceivemessages:
    'به صورت پیشفرض تمام شماره ها دریافت کننده پیام هستند',
  allNumbersReceiveMessages:
    'توجه: به صورت پیشفرض تمام شماره ها دریافت کننده پیام هستند',
  numberofselectedusers: 'تعداد کاربران انتخاب‌ شده: {text}',
  numberOfSelectedUsers: 'تعداد کاربران انتخاب‌ شده',
  noMessageHasBeenEntered: 'پیامی وارد نشده است',
  noNumberHasBeenSelected: 'هیچ شماره ای انتخاب نشده است',
  divertedNumber: 'شماره دایورتی',
  addNumber: 'ثبت شماره',
  registrationOfCallForwardNumber: 'ثبت شماره کال فوروارد',
  helpEnterTheDesiredNumberAndThenSaveIt:
    'راهنما: شماره مورد نظر را وارد و سپس آن را ذخیره نمایید',
  enterTheNumberWith98: 'شماره را با 98 وارد نمایید',
  enterTheMobileNumberWith98: 'شماره موبایل را با 98 وارد نمایید',
  usernameenterthemobilenumberwith98:
    '(نام کاربری) شماره موبایل را با 98 وارد نمایید',
  callforwardInsertSuccessfully: 'اطلاعات شماره کال فوروارد با موفقیت ثبت شد',
  callforwardDeleteSuccessfully: 'اطلاعات شماره کال فوروارد با موفقیت حذف شد',
  deleteCallforwardTitle: 'حذف شماره کال فوروارد',
  deleteCallforwardText: 'آیا از حذف شماره {item} مطمئن هستید؟',
  theEnteredNumberIsDuplicate: 'شماره وارد شده تکراری است',
  theEnteredNumberIsNotRegistered: `شماره وارد شده در ${companyName} ثبت نشده است.`,
  theEnteredUsernameIsDuplicate: 'نام‌کاربری وارد شده تکراری است',
  itispossibletoaddnumbersthatareintheblacklistfornotmakingcalls:
    'راهنما: در این قسمت، امکان افزودن شماره‌هایی که در لیست سیاه برای عدم برقراری تماس قرار می‌گیرند، وجود دارد',
  helpenterthenumberandclicksavetoentertheblacklist:
    'راهنما شماره را وارد و برای وارد شدن به لیست سیاه بر روی ذخیره کلیک نمایید',
  addNumberToBlackList: 'افزودن شماره به لیست سیاه',
  addNumberHere: 'افزودن شماره',
  blacklistInsertSuccessfully: 'اطلاعات شماره لیست سیاه با موفقیت ثبت شد',
  blacklistDeleteSuccessfully: 'اطلاعات شماره لیست سیاه با موفقیت حذف شد',
  deleteBlacklistTitle: 'حذف شماره لیست سیاه',
  deleteBlacklistText: 'شماره لیست سیاه حذف خواهد شد. اطمینان دارید؟',
  uploadthedesiredsoundintheuploadfieldandenteryouremailforthevoicemessage:
    'راهنما برای ایجاد پیام‌گیر صوتی، صوت مورد نظر را در قسمت آپلود بارگذاری کرده و برای پیام صوتی، ایمیل خود را وارد نمایید',
  addVoicemail: 'ایجاد پیام‌گیر صوتی',
  email: 'ایمیل',
  emailto: 'ایمیل شود به ...',
  importantnoteyourfilesizeshouldnotbemorethan5mbotherwisethefilewillnotbesent:
    'نکته مهم: حجم فایل شما نباید بیشتر از 5 مگابایت باشد. فرمت فایل باید mp3 یا wav باشد در غیر این صورت فایل ارسال نخواهد شد',
  voicemailMessages: 'پیام های پیام‌گیر صوتی',
  date: 'تاریخ',
  duration: 'مدت مکالمه',
  callTime: 'مدت مکالمه',
  messages: 'پیام‌ها',
  areYouSureToDeleteTheVoiceMail: 'آیا از حذف پیام صوتی شماره',
  voicemailInsertSuccessfully: 'اطلاعات پیام‌ صوتی با موفقیت ثبت شد',
  voicemailUpdateSuccessfully: 'اطلاعات پیام‌ صوتی با موفقیت ویرایش شد',
  voicemailDeleteSuccessfully: 'اطلاعات پیام‌ صوتی با موفقیت حذف شد',
  voicemailUploadSuccessfully: 'فایل پیام‌ صوتی با موفقیت آپلود شد',
  voicemailGreetingSuccessfully: 'فایل پیام‌ صوتی با موفقیت ثبت شد',
  voicemailmessageDeleteSuccessfully: 'پیام‌ صوتی با موفقیت حذف شد',
  deleteVoicemailTitle: 'حذف اطلاعات پیام‌گیر صوتی',
  deleteVoicemailText: 'آیا از حذف پیام‌گیر صوتی {item} مطمئن هستید؟',
  deleteVoicemailMesssageTitle: 'حذف پیام صوتی',
  deleteVoicemailMessageText: 'آیا از حذف پیام‌ صوتی {item} مطمئن هستید؟',
  deleteVoicemailmessageTitle: 'حذف پیام‌ صوتی',
  deleteVoicemailmessageText: 'پیام‌ صوتی حذف خواهد شد. اطمینان دارید؟',
  fileInput: 'انتخاب فایل',
  selectYourFiles: 'انتخاب فایل',
  answerTicket: 'پاسخ تیکت',
  responder: 'پاسخ دهنده',
  writer: 'نویسنده',
  addPerson: 'افزودن شخص',
  addNewPerson: 'افزودن شخص جدید',
  addExistingPerson: 'افزودن از اشخاص موجود',
  createNewPerson: 'ایجاد شخص',
  createNewCompany: 'ایجاد شرکت',
  addToExistsPerson: 'افزودن به شخص موجود',
  addToExistsCompany: 'افزودن به شرکت موجود',
  selectPerson: 'شخص را انتخاب کنید',
  selectCompany: 'شرکت را انتخاب کنید',
  viewContact: 'مشاهده مخاطب',
  addCompany: 'افزودن شرکت',
  addNewCompany: 'افزودن شرکت جدید',
  addExistingCompany: 'افزودن از شرکت‌های موجود',
  uploadInformation: 'بارگذاری اطلاعات',
  uploadInformationGuide:
    'شمادر اینجا میتوانید اطلاعات خود را از طریق بارگذاری فایل به صورت یکجا وارد کنید.',
  downloadJuridicaSampleFile: 'دانلود نمونه فایل (خریدار حقوقی)',
  downloadNaturalisSampleFile: 'دانلود نمونه فایل (خریدار حقیقی)',
  dropFileHear: 'فایل را بکشید و اینجا بیندازید  یا',
  xlsxFormat: 'فقط فایل با فرمت XLSX.',
  gotIt: 'متوجه شدم',
  someMinutesToUpdateInformation:
    'بروزرسانی اطلاعات شما ممکن است تا چند دقیقه دیگر طول بکشد. ',
  addTimecondition: 'ایجاد شرط زمانی',
  editTimecondition: 'ویرایش شرط‌های زمان بندی شده',
  helpitispossibletocreatetimeconditionstosetreceivingcallsindifferenttimeperiods:
    'راهنما امکان ایجاد شروط زمانی برای تنظیم دریافت تماس ها در بازه زمانی مختلف وجود دارد',
  priority: 'اولویت',
  timeconditionInsertSuccessfully: 'اطلاعات شرط زمانی با موفقیت ثبت شد',
  timeconditionUpdateSuccessfully: 'اطلاعات شرط زمانی با موفقیت ویرایش شد',
  timeconditionDeleteSuccessfully: 'اطلاعات شرط زمانی با موفقیت حذف شد',
  deleteTimeconditionTitle: 'حذف اطلاعات شرط زمانی',
  deleteTimeconditionText: 'آیا از حذف شرط زمانی {item} مطمئن هستید؟',
  noTimeCondition: 'هنوز شرط زمانی ثبت نشده.',
  enterAName: 'یک نام وارد کنید',
  conditions: 'شرایط',
  start: 'شروع',
  end: 'پایان',
  theProcess: 'عمل',
  accordingtotheprevioustimeconditionsenterthepriorityasanumber:
    'باتوجه به شروط زمانی قبلی الویت را به صورت عدد وارد کنید',
  Enter: 'وارد کنید',
  enter: 'وارد کنید',
  enterToNumber: 'به صورت عددی وارد کنید',
  select: 'انتخاب کنید',
  searchAndSelect: ' جستجو و انتخاب کنید',
  enable: 'فعال',
  year: 'سال',
  month: 'ماه',
  dayOfTheMonth: 'روزی از ماه',
  dayOfTheWeek: 'روزی از هفته',
  weekOfTheYear: 'هفته از سال',
  weekOfTheMonth: 'هفته از ماه',
  hour: 'ساعت',
  hourOfTheDay: 'ساعتی از روز',
  dateAndTime: 'تاریخ و ساعت',
  emptyNotification: 'هیج اعلانی برای شما وجود ندارد',
  fillingThisFieldIsMandatory: 'پر کردن این فیلد اجباری است',
  theNumberOfCharactersSelectedIsLessThanTheAllowedLimit:
    'تعداد کاراکتر انتخاب شده کمتر از حد مجاز است',
  theValueEnteredIsNotValid: 'مقدار وارد شده معتبر نیست',
  textCopied: 'متن کپی شد',
  responsiveOperator: 'اپراتور پاسخگو',
  allConversations: 'همه گفتگوها',
  unreadConversations: 'پیام خوانده نشده',
  readConversations: 'پیام خوانده شده',
  writeYourTextHere: 'پیام خود را یادداشت کنید..',
  thereIsNoDialogueToShow: 'گفتگویی برای نمایش وجود ندارد',
  chooseOneOfTheConversationsAndStart: 'یک یاز گفتگوها را انتخاب و شروع کنید',
  selectDepartment: 'انتخاب دپارتمان',
  selectOperator: 'انتخاب اپراتور',
  enterNameOrNumber: 'نام یا شماره مخاطب را وارد کنید',
  selectDateOfLastMessage: 'انتخاب تاریخ آخرین پیام',
  removeCdr: 'حذف سوابق تماس',
  alertForRemoveCdr: 'آیا از حذف سابقه تماس با شناسه {item} مطمئن هستید؟',
  alertForRemoveCdrs: 'آیا از حذف سوابق تماس انتخاب شده مطمئن هستید؟',
  fromTime: 'از ساعت',
  toTime: 'تا ساعت',
  numbersOf: 'شماره‌های {title}',
  divertNumbers: 'شماره های دایورتی',
  callCenters: 'مراکز تماس',
  ivrMenus: 'منوهای IVR',
  voiceMail: 'پیام گیر صوتی',
  fieldRequired: 'فیلد اجباری است',
  completeRequiredField: 'فیلدهای اجباری را با دقت پر کنید.',
  users: 'کاربران',
  addedExtention: 'افزودن داخلی',
  company: 'شرکت',
  noData: 'هنوز داده ای ایجاد نشده است!',
  evaluationInfo: 'اطلاعات ارزیابی کننده',
  evaluationMaster: 'کارشناس ارزیابی کننده',
  evaluationDate: 'تاریخ ارزیابی:',
  evaluation: 'ارزیابی',
  oprator: 'اپراتور',
  evaluationTime: ' زمان ارزیابی',
  ringing: 'در حال زنگ خوردن',
  itemsPerPage: 'تعداد در هر صفحه',
  from: 'از',
  to: 'تا',
  into: 'به',
  realTimeMonitoringOfTheCallCenter: 'پایش لحظه ای مرکز تماس',
  diconectDeatail: 'دلیل قطع ارتباط',
  create: 'ایجاد',
  send: 'ارسال',
  sendASingle: 'ارسال تکی',
  sendASingleSms: 'ارسال پیامک تکی',
  createSms: 'ایجاد پیامک',
  sendReport: 'گزارش ارسال',
  reportReceive: 'گزارش دریافت',
  noConferenceReport: 'رویدادی یافت نشد.',
  messageSubject: 'موضوع پیامک',
  selectTheSourceNumber: 'انتخاب شماره مبدا',
  enterSubject: 'موضوع را وارد کنید',
  enterText: 'متن را وارد کنید',
  selectSubject: 'انتخاب موضوع پیش‌فرض',
  saveSubject: 'ذخیره در پیش فرض ها',
  selectText: 'انتخاب متن پیش‌فرض',
  saveText: 'ذخیره در پیش فرض ها',
  defaultSubjects: 'موضوع های پیشفرض',
  defaultMessages: 'پیام های پیش فرض',
  paste: 'جاگذاری',
  sendSms: 'ارسال پیامک',
  sendTiming: 'زمان بندی ارسال',
  sendConfirmation: 'تایید ارسال',
  sendConfrimationText: 'آیا از ارسال پیامک مطمئن هستید؟',
  noBack: 'خیر، بازگشت',
  yesSend: 'بله , ارسال',
  yesRemove: 'بله , حذف',
  yesSubmit: 'بله , تائید',
  confirmation: 'تائید',
  reciversCount: 'تعداد گیرندگان',
  sendingPrice: 'هزینه ارسال',
  setSendTime: 'زمان دهی ارسال',
  selectSendDate: 'انتخاب تاریخ ارسال',
  selectReceiveDate: 'انتخاب تاریخ دریافت',
  minuteHour: '(دقیقه/ساعت)',
  reportReceiveSend: 'گزارش ارسال و دریافت',
  reportSend: 'گزارش ارسال ',
  sendStatus: 'وضعیت ارسال',
  filter: 'فیلتر',
  usersMonitoring: 'مانیتورینگ کاربران',
  sendABulk: 'ارسال انبوه',
  sendBulkGuide: 'راهنما: شما امکان ارسال پیامک به یک گیرنده را دارید.',
  uploadContactsFile: 'آپلود فایل مخاطبین',
  sendAGroupsSms: 'ارسال  گروهی',
  selectGroupContacts: 'انتخاب گروه مخاطبین',
  groupContacts: ' گروه مخاطبین',
  createGroup: 'ایجاد گروه',
  createGroupContacts: 'ایجاد گروه مخاطبین',
  enterNameGroup: 'نام گروه را وارد کنید',
  enterPhone: 'ورود شماره تلفن',
  daily: 'روزانه',
  weekly: 'هفتگی',
  monthly: 'ماهانه',
  selectDate: 'انتخاب تاریخ',
  smsCount: 'تعداد پیامک',
  characterCount: 'تعداد حرف',
  contactsCount: 'تعداد مخاطب',
  contactNumber: 'شماره مخاطب',
  cancelSend: 'لغو ارسال',
  selectedContactCount: 'تعداد مخاطب انتخاب شده',
  contact: 'مخاطب',
  enterContactNumber: 'ورود شماره تماس مخاطب',
  contactsGroup: 'گروه مخاطبین',
  contactsList: 'دفترچه تلفن',
  selectFromContactList: 'انتخاب از دفترچه تلفن',
  addToContactsList: 'افزودن به دفترچه تلفن',
  enterName: 'نام خود را وارد کنید',
  enterLastname: 'نام خانوادگی خود را وارد کنید',
  searchNameOrPhone: 'شماره با نام را جستجو کنید',
  editSingleSms: 'ویرایش پیامک تکی',
  editSendTiming: 'ویرایش زمان‌بندی ارسال',
  editConfirmation: 'تایید ویرایش',
  editConfrimationText: 'آیا از ویرایش پیام خود مطمئن هستید؟',
  editSetSendTime: 'ویرایش زمان دهی ارسال',
  editGroupSms: 'ویرایش پیامک گروهی',
  retrySend: 'تلاش مجدد',
  reportStatusSend: 'گزارش وضعیت ارسال',
  originNumber: 'شماره مبدا',
  id: 'شناسه',
  sendGroupsSms: 'ارسال پیامک گروهی',
  firstCreateContactGroup: 'ابتدا گروه مخاطبین را ایجاد کنید',
  groupsContacts: 'گروه‌های مخاطبین',
  removeGroupContacts: 'حذف گروه مخاطبین',
  removeGroupText: 'آیا از حذف گروه مطمئن هستید؟',
  editGroupContacts: 'ویرایش گروه مخاطبین',
  sendTime: 'زمان ارسال',
  now: 'اکنون',
  selectSendTime1: 'زمان را انتخاب کنید',
  communicationPort: 'درگاه ارتباطی',
  groupEvaluation: 'گروه سنجش',
  scoreCoefficient: 'ضریب امتیاز',
  totalScore: 'مجموع امتیاز',
  totalScores: 'مجموع امتیازات',
  minute: 'دقیقه',
  second: 'ثانیه',
  submitEva: 'ثبت ارزیابی',
  editEvaluation: 'ویرایش ارزیابی عملکرد',
  contactName: 'نام مخاطب',
  operatorName: 'نام اپراتور',
  noSearch:
    'برای نمایش گزارش، تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!',
  userQaQc: 'کاربر',
  smstype: 'نوع پیامک',
  smsTypeReceive: 'نوع پیامک دریافتی',
  smsDetailsReceived: 'جزئیات پیامک دریافتی',
  productsList: 'لیست محصولات',
  noReport: 'گزارش مورد نظر پیدا نشد!',
  nothingFound: 'چیزی یافت نشد!',
  noReportProductsList1:
    'هنوز محصولی افزوده نشده است، برای افزودن دستی روی دکمه زیر کلیک کنید.',
  noReportProductOptionList: 'برای این محصول نسخه‌ای ثبت نشده است.',
  noProductHaveBeenRegisteredYetInDeal:
    'هنوز محصولی برای این فرصت فروش ثبت نشده است',
  addYourProductInInvoice:
    'محصول مورد نظر خود را در پیش‌فاکتور یا فاکتور ثبت کنید',
  noReportProductsList2: 'برای بارگذاری فایل روی دکمه زیر کلیک کنید.',
  noReportProductsList3: 'محصول مورد جستجو یافت نشد!',
  downloadSample: 'دانلود نمونه',
  addNewProduct: 'افزودن محصول',
  porductName: 'عنوان محصول',
  porductCode: 'کد محصول',
  deleteProduct: 'حذف محصول',
  deleteProductText: 'آیا از حذف محصول {item} مطمئن هستید؟',
  deleteProductOption: 'حذف نسخه',
  areYouSureToDeleteProductOption: 'آیا از حذف این نسخه مطمئن هستید؟',
  areYouSureToDeleteNumberSelectedProducts:
    'آیااز حذف {number} محصول انتخاب شده مطمئن هستید؟',
  addNewCategory: 'افزودن دسته‌بندی',
  categoryList: 'دسته‌بندی محصولات',
  productsNumber: 'تعداد محصولات',
  viewProducts: 'مشاهده محصولات',
  viewmore: 'مشاهده بیشتر',
  viewless: 'مشاهده کمتر',
  mainSpec: 'مشخصات اصلی',
  productspec: 'مشخصات محصول',
  productRemoveNotAllow: 'این محصول در انبار موجود است. امکان حذف نیست.',
  currency: 'ارز',
  porductCurrency: 'ارز واحد',
  porductUnitPrice: 'قیمت واحد',
  porductUnit: 'واحد اندازه‌گیری',
  porductCategory: 'دسته‌بندی',
  porductCount: 'موجودی',
  productOptions: 'نسخه‌های محصول',
  addVersionValue: 'افزودن مقدار ویژگی',
  addVersion: 'افزودن نسخه',
  versionAmount: 'نام نسخه',
  versionCode: 'کد نسخه',
  versionCost: 'قیمت نسخه',
  versionCount: 'موجودی نسخه',
  versionFile: 'بارگذاری تصویر نسخه',
  uploadImage: 'بارگذاری تصویر',
  searchKey: 'کلمه کلیدی',
  addProductInInventory: 'افزایش موجودی از طریق ورود به انبار انجام می‌شود.',
  register: 'ثبت',
  deletecategorytext: 'آیا از حذف دسته‌بندی  {item} مطمئن هستید؟',
  deleteCategory: 'حذف دسته‌بندی',
  categoryEdit: 'ویرایش دسته‌بندی',
  categoryName: 'عنوان دسته‌بندی',
  deleteCategoryProducts: 'محصولات این دسته‌بندی حذف شوند.',
  categoryProductsChange: 'محصولات این دسته‌بندی به دسته دیگر اضافه شود.',
  productQuantityCannotBeZero: 'مقدار محصول نمی تواند صفر باشد',
  categoryTitle: 'عنوان دسته‌بندی',
  enterPhoneNumberSendSingle:
    'ورود شماره تلفن (شما میتوانید حداکثر 5 دریافت کننده انتخاب کنید)',
  callCount: 'تعداد تماس',
  waitingTime: 'زمان انتظار',
  productWithStorage: 'محصول (با انبارداری)',
  productWithoutStorage: 'محصول (بدون انبارداری)',
  enterDescription: 'توضیحات را وارد کنید',
  retry: 'تلاش مجدد',
  manager: 'مدیریت',
  evaluationWithAdmin: 'بررسی ارزیابی توسط مدیر',
  evaluationWithExpret: 'بررسی ارزیابی توسط کارشناس',
  managerScoreSubmited: 'امتیاز ثبت شده توسط مدیر',
  reportEvaluationUser: 'گزارش عملکرد کاربران',
  downloadSounds: 'دانلود صوت ها',
  downloadSelectedSounds: 'دانلود صوت‌های انتخاب‌شده',
  deleteSounds: 'حذف صوت ها',
  deleteSelectedSounds: 'حذف صوت‌های انتخاب‌شده',
  createTicket: 'ایجاد تیکت',
  selectCallDate: 'انتخاب تاریخ تماس',
  user: 'کاربر',
  inventory: 'انبار',
  ticket: 'تیکت',
  noTicket: 'هنوز تیکت ایجاد نشده است.',
  clickForCreateTicket: 'برای ایجاد تیکت روی دکمه زیر کلیک کنید.',
  newTicket: 'ایجاد تیکت',
  ticketTitle: 'عنوان تیکت',
  registeredTitles: 'عنوان‌های ثبت‌ شده‌',
  createInventory: 'ایجاد انبار',
  interProductToInventory: 'ورود محصول به انبار',
  inventoryManager: 'مدیر انبار',
  province: 'استان',
  addQuantity: 'افزودن موجودی',
  tipTypes: 'فقط فایل‌های فرمت {types}',
  tipMaxSize: 'تا حجم {size}',
  tipMaxFiles: 'حداکثر تا {count} فایل',
  quantityInsertSuccessfully: 'موجودی با موفقیت افزوده شد.',
  searchInputInventoryPlaceholder:
    'جستجوی نام انبار، آدرس، تلفن یا توضیحات انبار',
  inventoryEmptyTitle: 'هنوز انبار ایجاد نشده است.',
  createInventoryGuideText: 'ثبت اطلاعات زیر اختیاری است.',
  location: 'آدرس',
  updateInventory: 'ویرایش انبار',
  downloadSampleFile: 'دانلود نمونه فایل',
  interProduct: 'ورود محصول',
  inventoryName: 'نام انبار',
  interDate: 'تاریخ ورود',
  productVersion: 'نسخه محصول',
  product: 'محصول',
  quantity: 'موجودی',
  addProduct: 'افزودن محصول',
  deductProduct: 'خروج محصول',
  enterQuantity: 'تعداد محصول را وارد کنید',
  inventoryInfo: 'اطلاعات انبار',
  qaqcEmptyGuideText:
    'برای نمایش گزارش، تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!',
  qaqcEmptyListGuideText:
    'برای نمایش فهرست تماس ها , تاریخ یا فیلتر مورد نظر خود را انتخاب و سپس روی دکمه جستجو کلیک کنید!',
  searchAndSelected: 'جستجو و انتخاب کنید',
  enterPhoneNumber: 'ورود شماره تماس',
  addFilter: 'افزودن فیلتر',
  qaqcNoResultGuideText: 'سابقه تماس یافت نشد!',
  qaqcReportUserNoResultGuideText: 'گزارش یافت نشد!',
  searchProductNameAndProductCode: 'جستجو نام , کد محصول',
  inventoryHistory: 'تاریخچه انبار',
  invUser: 'کاربر',
  inv: 'انبار را به',
  createInv: 'را ایجاد کرد',
  invChanged: 'تغییر داد',
  phone: 'تلفن',
  name: 'نام',
  removeInventory: 'حذف انبار',
  inventoryProductEmptyTitle: 'هنوز محصولی وارد این انبار نشده است.',
  productsFromThisWarehouseShouldBeRemoved: 'محصولات این انبار حذف شوند.',
  theProductsFromThisWarehouseWillBeTransferredToAnotherWarehouse:
    'محصولات این انبار به انبار دیگر منتقل شود.',
  selectWarehouse: 'انتخاب انبار',
  deletedInv: 'انبار را حذف کرد',
  viewResultEvaluation: 'مشاهده نتیجه ارزیابی',
  reviewingTheEvaluationResults: 'بررسی نتیجه ارزیابی',
  Unpin: 'برداشتن سنجاق',
  unpin: 'برداشتن سنجاق',
  unPin: 'برداشتن سنجاق',
  addTaskText: 'برای افزودن وظیفه روی دکمه زیر کلیک کنید.',
  viewtask: 'مشاهده وظیفه',
  untilYesterday: 'تا دیروز',
  fromTomorrow: 'از فردا',
  executionTime: 'مدت زمان انجام',
  taskUpdateSuccessfully: 'وظیفه با موفقیت ویرایش شد',
  taskAddedSuccessfully: 'وظیفه با موفقیت اضافه شد',
  errorAddingTask: 'خطا در افزودن وظیفه',
  taskHistory: 'تاریخچه وظیفه',
  taskNumber: 'وظیفه شماره',
  writeYourOpinion: 'نظر خود را یادداشت کنید...',
  leads: 'سرنخ‌ها',
  lead: 'سرنخ',
  leadNotFound: 'سرنخی یافت نشد.',
  addLead: 'افزودن سرنخ',
  addTask: 'افزودن وظیفه',
  createdate: 'تاریخ ایجاد',
  lastConnectionDate: 'تاریخ آخرین ارتباط',
  lastConectionDate: 'تاریخ آخرین ارتباط',
  lastConectionDatee: 'تاریخ آخرین ارتباط',
  idCommunicationPort: 'شناسه درگاه ارتباطی',
  leadCreateDate: 'تاریخ ایجاد سرنخ',
  searchContactPhoneOrLeadName: 'جستجوی نام سرنخ',
  advancedSearch: 'جستجوی پیشرفته',
  contactNameOrNumberFieldSearch: 'نام مخاطب، شماره ',
  men: 'آقا',
  women: 'خانم',
  in: 'در',
  lastFollow: 'تاریخ آخرین پیگیری',
  resultOfTheLastConnection: 'نتیجه آخرین ارتباط',
  registrationExpert: 'کارشناس ثبت کننده',
  submited: 'ثبت کننده',
  fristnameAndLastname: 'نام و نام خانوادگی',
  addNewLead: 'افزودن سرنخ',
  resultLastConection: 'نتیجه آخرین ارتباط',
  thisLeadConvertedToContact: 'این سرنخ به مخاطب تبدیل شده است',
  dealCreatedFromThisLead: 'این فرصت فروش از این سرنخ ساخته شده است',
  onlyjpegpngformatfilesupto1mbinsize:
    'فقط فایل‌های فرمت JPEG, PNG  تا حجم 1MB.',
  info: 'جزئیات',
  leadInfo: 'اطلاعات سرنخ',
  leadsubtitle: 'سمت در',
  leadSubtitle2: 'کسب و کار',
  leadName: 'نام سرنخ',
  successfullyArchived: 'با موفقیت در آرشیو ذخیره شد',
  unarchive: 'خروج از آرشیو',
  successfullyUnarchived: 'با موفقیت از آرشیو خارج شد',
  tasks: 'وظیفه‌ها',
  notFoundNoteText: 'هنوز یادداشتی ایجاد نشده است.',
  notFoundTask: 'وظیفه‌ای یافت نشد',
  taskTitleAndType: 'عنوان و نوع وظیفه',
  creator: 'ایجاد کننده',
  allTasks: 'همه وظیفه‌ها',
  searchTasksTitle: 'جستجوی عنوان و کد وظیفه',
  todayTasks: 'وظیفه‌های امروز',
  expiredTasks: 'وظیفه‌های عقب‌افتاده',
  futureTasks: 'وظیفه‌های آینده',
  high: 'بالا',
  low: 'پایین',
  medium: 'متوسط',
  noPriority: 'بدون اولویت',
  editTask: 'ویرایش وظیفه',
  addConnection: 'ایجاد ارتباط',
  connections: '{item} ارتباط',
  selected: 'انتخاب شده',
  person: 'شخص',
  doer: 'انجام دهنده',
  responsiblePerson: 'مسئول انجام',
  convertToContact: 'تبدیل به مخاطب',
  saveToArchive: 'ذخیره در آرشیو',
  convertLeadType: 'نوع تبدیل سرنخ را انتخاب کنید:',
  addedForLinkContact: 'اضافه کردن به مخاطب موجود',
  addedForNewContact: 'اضافه کردن به عنوان مخاطب جدید',
  fullName: 'نام و نام خانوادگی',
  selectContactType: 'نوع مخاطب را انتخاب کنید',
  contactType: 'نوع مخاطب',
  selectConvertType: 'نوع تبدیل را انتخاب کنید',
  nextActivityDate: 'تاریخ فعالیت بعدی',
  activityDate: 'تاریخ تعامل',
  searchTitleForTicketOrClient: 'جستجوی عنوان، شماره تیکت یا مخاطب',
  ticketDeleteModalTitle: 'حذف تیکت',
  ticketDeleteModalText: 'آیا از حذف تیکت "{item}" مطمئن هستید؟',
  noTicketFound: 'تیکتی یافت نشد.',
  checkoutTicket: 'بررسی تیکت',
  tickets: 'تیکت‌ها',
  ticketDeleteSuccessfully: 'تیکت با موفقیت حذف شد',
  ticketInfo: 'اطلاعات تیکت',
  addToContact: 'افزودن به مخاطبین',
  archived: 'آرشیو',
  registrar: 'ثبت کننده',
  addNote: 'ثبت یادداشت',
  Notetext: 'متن یادداشت',
  addNoteText: 'برای افزودن یادداشت روی دکمه زیر کلیک کنید.',
  notePinnedSuccessfully: 'یادداشت با موفقیت سنجاق شد',
  pin: 'سنجاق',
  unpinSuccessfully: 'سنجاق با موفقیت برداشته شد.',
  addNoteSuccess: 'یادداشت با موفقیت افزوده شد',
  onlyJpegPngFormatFilesUpTo1mbInSize:
    'فقط فایل‌های فرمت JPEG, PNG  تا حجم 1MB.',
  noCallHistory: 'سابقه تماس یافت نشد!',
  noUser: 'اپراتوری تعریف نشده است.',
  noDepartment: 'دپارتمانی تعریف نشده است.',
  noWeb:
    'هنوز وب‌سایتی افزوده نشده است، برای افزودن وب‌سایت روی دکمه زیر کلیک کنید:',
  noLink: 'لینکی تعریف نشده است.',
  noForward: 'هنوز شماره ای ثبت نشده است.',
  notFound: 'چیزی یافت نشد.',
  noBlackListNumber: 'هنوز شماره‌ای در لیست سیاه قرار نگرفته‌است.',
  noVoiceMail:
    'هنوز پیام‌گیر صوتی ایجاد نشده است، برای ایجاد آن روی دکمه زیر کلیک کنید.',
  noRecording: 'هنوز فایلی بارگذاری نشده.',
  sendACorresponding: 'ارسال متناظر',
  sendCorrespondingSms: 'ارسال پیامک متناظر',
  selectSendTime: 'انتخاب زمان ارسال',
  selectSendDateAndTime: 'انتخاب تاریخ و زمان ارسال',
  correspondingTableText:
    'با قابلیت ارسال متناظر این امکان را دارید که برای هر شماره، متنی منحصر بفرد ارسال کنید. \n' +
    'برای این منظور طبق فایل نمونه، شماره‌ها و متن‌ مختص به آن را آماده  و سپس فایل را بارگذاری کنید.',
  sendAParametric: 'ارسال پارامتریک',
  sendParametricSms: 'ارسال پیامک پارامتریک',
  board: 'بورد',
  reply: 'پاسخ',
  assignToOther: 'اختصاص به دیگری',
  assignToUser: 'اختصاص به کاربر',
  ticketAnswer: 'پاسخ تیکت',
  enterTicketAnswer: 'پاسخ تیکت را وارد کنید!',
  ticketStatus: 'وضعیت تیکت',
  submitReply: 'ثبت پاسخ',
  enterNewAgent: 'کارشناس پیگیری جدید را انتخاب کنید',
  parametricTableText:
    'دراین بخش این امکان را دارید که برای هر شماره، متنی منحصر بفرد را بر اساس متغیرهای مختص به هر مخاطب ارسال نمایید. \n' +
    'برای این منظور طبق فایل نمونه، شماره‌های خود و متغیرهای آن را آماده و سپس فایل را بارگذاری کنید.',
  sample: 'نمونه',
  previewNumberAndTextOfSms: 'پیش‌نمایش شماره و متن پیامک',
  changesHaveBeenLoaded: 'متغیرهای بارگذاری‌شده',
  previewnumberandtextofsms: 'پیش‌نمایش شماره و متن پیامک',
  inactiveCategory: 'دسته‌بندی انتخاب شده غیر فعال است!',
  inactiveCategoryOfProduct: 'دسته‌بندی محصول انتخاب شده غیر فعال است!',
  productsOfThisCategoryAreExists:
    'محصولات این دسته‌بندی در انبار موجودی دارند',
  theProductCodeIsDuplicate: 'کد محصول تکراری است!',
  theCategoryIsDuplicate: 'دسته‌بندی تکراری است!',
  productEditSuccess: 'ویرایش محصول با موفقیت انجام شد',
  categoryEditSuccess: 'ویرایش دسته‌بندی با موفقیت انجام شد',
  fileIsNotValid: 'فایل معتبر نیست!',
  assignedTo: 'کارشناس پیگیری',
  ticketType: 'نوع تیکت',
  audienceFeeling: 'حس مخاطب',
  latestActivityDate: 'تاریخ آخرین فعالیت',
  choseBoardFirst: 'ابتدا برد انتخاب شود',
  registerDuty: 'ثبت وظیفه',
  leadEmptyTitle: 'سرنخی وجود ندارد برای ایجاد سرنخ رو دکمه زیر کلیک کنید',
  leadEmptyTitleArchived: 'سرنخ آرشیو شده‌ای وجود ندارد',
  archiveEmptyTitle: 'آرشیوی وجود ندارد',
  hide: 'پنهان کردن',
  show: 'نمایش دادن',
  salesOpportunities: 'فرصت‌های فروش',
  createSalesOpportunities: 'ایجاد فرصت‌ فروش',
  salesOpportunitiesTitle: 'عنوان فرصت فروش',
  expectedClosingDate: 'تاریخ مورد انتظار بسته‌شدن',
  amountCalculationType: 'نوع محاسبه مبلغ',
  addExtraProduct: 'افزودن محصول دیگر',
  noDataFound: 'موردی یافت نشد.',
  noDealFound: 'موردی یافت نشد.',
  newDeal: 'ایجاد فرصت فروش',
  noDealCreatedYet: 'هنوز فرصت فروشی ایجاد نشده است.',
  clickButtonBelowToCreateDeal: 'برای ایجاد فرصت فروش روی دکمه زیر کلیک کنید',
  dealDeleteModalTitle: 'حذف فرصت فروش',
  dealDeleteModalText: 'آیا از حذف فرصت فروش مطمئن هستید؟',
  dealChangeStepText: 'آیا از تغییر وضعیت ”فرصت فروش”  به {item} مطمئن هستید؟',
  checkoutDeal: 'بررسی فرصت فروش',
  successDeal: 'فروش موفق',
  failedDeal: 'فروش ناموفق',
  changeStep: 'تغییر وضعیت',
  totalSales: 'جمع کل فروش',
  numberOfSuccessDeal: 'تعداد فرصت‌های فروش موفق',
  averageSuccessRate: 'میانگین نرخ موفقیت',
  confirmDealText: 'بله، تایید',
  dealMenu: 'فرصت‌های فروش',
  createTime: 'تاریخ ایجاد',
  nextFollowup: 'فعالیت آتی',
  remainingTimestamp: 'تاریخ مورد انتظار بسته شدن',
  updatedAt: 'آخرین بروزرسانی',
  desc: 'جدیدترین',
  asc: 'قدیمی‌ترین',
  deals: 'فرصت‌های فروش',
  deal: 'فرصت فروش',
  dealLine: 'تاریخ مورد انتظار بسته‌شدن',
  nofax: 'هنوز فکسی افزوده نشده است، برای افزودن فکس روی دکمه زیر کلیک کنید!',
  editDeal: 'ویرایش فرصت فروش',
  contactGroupCreatedSuccessfully: 'گروه مخاطبین با موفقیت ایجاد شد!',
  contactGroupRemovedSuccessfully: 'گروه مخاطبین با موفقیت حذف شد!',
  contactGroupUpdatedSuccessfully: 'گروه مخاطبین با موفقیت تغییر کرد!',
  searchForDealUserNameOrNumber: 'جستجوی شماره یا نام خریدار',
  nextFollowupTaskDate: 'تاریخ وظیفه بعدی',
  basedonproduct: 'بر اساس محصول',
  converted: 'تبدیل شده',
  assign: 'اختصاص دادن',
  addDealForLead: 'ایجاد فرصت فروش برای مخاطب',
  added: 'اضافه شد',
  justContact: 'به مخاطبین اضافه شد',
  contactWithDeal: 'به مخاطبین و معامله ها اضافه شد',
  showMore: 'نمایش بیشتر',
  programmersSpecial: 'ویژه برنامه نویسان',
  newotp: 'ثبت الگو',
  otpcode: 'کد OTP',
  templatetitle: 'عنوان الگو',
  templatetext: 'متن الگو',
  entertemplatetext: 'متن قالب را وارد کنید!',
  numberotpdigits: 'تعداد ارقام OTP',
  validityPeriodCode: 'مدت زمان اعتبار کد',
  sendingLimitPerHour: 'محدودیت ارسال در هر ساعت',
  maximumNumberAttempts: 'حداکثر دفعات تلاش تایید',
  WebsiteName: 'نام وبسایت',
  newOtpKeyWord:
    'برای جایگذاری پارامترهای زیر در داخل متن پیامک از دکمه زیر استفاده کنید.',
  enterurladdress: 'آدرس URL را وارد کنید',
  templatecreationguide: 'راهنمای ایجاد الگو',
  otphelperfirstp:
    'بااستفاده از این قابلیت، شما می‌توانید پیامک‌هایی با محتوای حساس، فوری و پویا مانند کد تأیید (OTP)، کد فعال‌سازی، اطلاع‌رسانی‌های امنیتی، فاکتور خرید یا وضعیت سفارش را از طریق خطوط خدماتی برای کاربران خود ارسال نمایید.',
  otphelperfirstli:
    'ارسال از طریق خطوط خدماتی این امکان را فراهم می‌سازد که پیامک حتی به کاربرانی که دریافت پیامک تبلیغاتی را مسدود کرده‌اند نیز برسد. این نوع پیامک‌ها اولویت بالایی در صف ارسال دارند و برای تعاملات مهم و حیاتی طراحی شده‌اند.',
  templatecreationsteps: 'مراحل ایجاد قالب',
  enteryourmessagetext: 'متن پیامک خود را وارد کنید.',
  otpsendtosupport:
    'قالب شما برای بررسی و تأیید به تیم پشتیبانی ارسال خواهد شد.',
  otpuseinapitext:
    'می‌توانیداز این قالب در ارسال پیامک‌های سیستمی یا از طریق API استفاده کنید.',
  rulesandrequirementsinsms: 'قوانین و الزامات استفاده از پیامک خدماتی',
  otphelperfirstlitext:
    'متن پیامک باید صرفاً اطلاع‌رسانی باشد و محتوای تبلیغاتی در آن مجاز نیست.',
  otphelpersecondlitext:
    'استفاده از عبارات تبلیغاتی مانند «تخفیف»، «هدیه»، «جایزه»، «فروش ویژه» باعث رد قالب یا مسدود شدن خط خدماتی خواهد شد.',
  otphelperthirdlitext: 'قالب باید دارای ساختار سیستمی و کاربردی باشد.',
  otphelperfourthlitext:
    'هرمتغیر استفاده‌شده در متن، هنگام ارسال باید مقداردهی شود.',
  otphelperfifthlitext:
    'برای هر نوع پیام (ورود، فراموشی رمز عبور، تأیید سفارش...) باید قالب جداگانه تعریف شود.',
  getapikey: 'دریافت API key',
  copyapikey: 'کپی API key',
  sendtest: 'ارسال تست',
  enteryournumberforsendtestsms:
    'شماره مورد نظر خود را برای ارسال پیامک تست وارد کنید',
  sendernumber: 'شماره فرستنده',
  forcreattemplateclick: 'برای ایجاد الگو روی دکمه زیر کلیک کنید.',
  templateCreatedSuccessfully: 'الگو با موفقیت ایجاد شد.',
  templateEditedSuccessfully: 'الگو با موفقیت ویرایش شد.',
  testSmsSentSuccessfully: 'پیامک تست با موفقیت ارسال شد.',
  searchTitleTextOrWebsiteName: 'جستجوی عنوان، متن یا نام وبسایت',
  otpCodeHasNotBeenInsertedYet: 'کد otp هنوز جایگذاری نشده است.',
  senderNumberWasSuccessfullyChanged: 'شماره فرستنده با موفقیت تغییر یافت.',
  deleteTemplate: 'حذف الگو',
  areYouSureDeleteTemplate: 'آیا از حذف الگو مطمئن هستید؟',
  templateWasSuccessfullyDeleted: 'الگو با موفقیت حذف شد.',
  enterLeadNameNumberOrSourceChannelId:
    'نام، شماره سرنخ، شناسه درگاه ارتباطی را وارد کنید',
  lastDoneDutyDate: 'تاریخ آخرین وظیفه انجام‌شده',
  nextDutyDate: 'تاریخ وظیفه بعدی',
  latestCommunicationDate: 'تاریخ آخرین ارتباط',
  resultOfLastContact: 'نتیجه آخرین ارتباط',
  filters: 'فیلترها',
  enterTicketNumberOrTitleOrDescription:
    'شماره، عنوان یا توضیحات تیکت را وارد کنید',
  creatorAgent: 'کارشناس ایجاد کننده',
  submiterAgent: 'کارشناس ثبت کننده',
  latestUpdateDate: 'تاریخ آخرین بروزرسانی',
  userFeeling: 'حس مخاطب',
  tryAggain: 'دوباره تلاش کنید',
  ticketDeleteAllSelectedTicketsModalText:
    'آیااز حذف تیکت‌های انتخاب شده مطمئن هستید؟',
  itemsSelected: 'مورد انتخاب شده',
  supportNavatel: 'پشتیبانی نواتل',
  whatsappNoNumber:
    'برای ایجاد ارتباط، ابتدا شماره واتس‌اپ مخاطب را در اطلاعات اصلی وارد کنید.',
  whatsappNoConnection:
    'برای شروع مکالمه در واتس‌اپ، لطفاً ابتدا شماره واتس‌اپ خود را در تنظیمات کاربری وارد کنید.',
  conversationWithConttactNotStartedOnWhatsApp:
    'هنوز مکالمه‌ای با این مخاطب در واتس‌اپ آغاز نشده است.',
  conversationWithContactNotStartedOnNavatel:
    'هنوز مکالمه‌ای با این مخاطب در نواتل آغاز نشده است.',
  returnChatPage: 'بازگشت به صفحه چت',
  files: 'فایل‌ها',
  nameContact: 'نام شخص حقیقی',
  onlineChatNoNumber:
    'برای ایجاد ارتباط، ابتدا شماره نواتل مخاطب را در اطلاعات اصلی وارد کنید.',
  changeStatusToDone: 'تغییر وضعیت به انجام شده',
  changeStatusToNotDone: 'تغییر وضعیت به انجام نشده',
  done: 'انجام شده',
  overdue: 'عقب‌افتاده',
  noConnections: 'بدون ارتباط',
  toDo: 'برای انجام',
  phoneCall: 'تماس تلفنی',
  sendEmail: 'ارسال ایمیل',
  errorAddComment: 'خطا در ثبت نظر',
  showLess: 'نمایش کمتر',
  enterprice: 'ورود مبلغ',
  delete: 'حذف',
  viewEvaluation: 'مشاهده ارزیابی',
  qaqcWarningHintForSelectingDepartment:
    'برای مشاهده شاخص‌های ارزیابی، ابتدا دپارتمان مورد نظر خود را انتخاب کنید.',
  chosingDepartment: 'انتخاب دپارتمان',
  criteria: 'شاخص‌',
  scoreMultiplyer: 'ضریب امتیاز',
  scoresSum: 'مجموع امتیازات',
  scoreSum: 'مجموع امتیاز',
  scoreAverage: 'میانگین امتیاز',
  choseScore: 'انتخاب امتیاز',
  evaluatorExpert: 'کارشناس ارزیابی',
  evaluatorTime: 'مدت ارزیابی',
  submitEvaluation: 'ثبت ارزیابی',
  managment: 'مدیریت',
  noEvaluationYet: 'ارزیابی نشده',
  leavingComment: 'ثبت نظر',
  managmentComment: 'نظر مدیریت',
  managmentScore: 'کیفیت ارزیابی',
  commentDate: 'تاریخ نظر',
  enterDescriptions: 'توضیحات را وارد کنید!',
  noCommentSubmitted: 'نظری ثبت نشده',
  newAction: 'عملیات جدید',
  addPeopleAndCompany: 'اضافه‌به‌شخص‌/شرکت',
  setRecurringTask: 'تنظیم تکرار وظیفه',
  recurrenceType: 'اتخاب دوره تکرار',
  recurrenceCount: 'تعداد تکرار',
  recurrenceEndDate: 'انتخاب تاریخ پایان',
  nonWorkingDaysAreNotIncluded: 'روزهای غیرکاری لحاظ نشود',
  times: 'مرتبه',
  dealTitleSearch: 'عنوان فرصت فروش، نام خریدار',
  noPrice: 'بدون مبلغ',
  notSet: 'تعیین نشده',
  assignedDate: 'تاریخ اختصاص',
  assignToExpert: 'اختصاص دادن به کارشناس',
  assignToOperator: 'اختصاص دادن به کاربر',
  createTask: 'ایجاد وظیفه',
  searchLeadNameAndCommuunicationId:
    'جستجو نام، نام خانوادگی و شناسه ارتباطی سرنخ',
  assignDate: 'تاریخ تخصیص',
  assign_date: 'تاریخ تخصیص',
  firstDoneTaskDate: 'تاریخ اولین وظیفه انجام‌شده',
  lastDoneTaskDate: 'تاریخ آخرین وظیفه‌انجام‌شده',
  allocationDate: 'تاریخ تخصیص',
  firstDoneDutyDate: 'تاریخ اولین وظیفه انجام‌شده',
  upcomingTaskDate: 'تاریخ وظیفه بعدی',
  latestDoneTaskDate: 'تاریخ آخرین وظیفه انجام شده',
  expectedDateOfClosure: 'تاریخ مورد انتظار بسته شدن',
  delayedDealOnClosure: 'فرصت‌های فروش دارای تأخیر در بسته شدن',
  hasProformaInvoiceOrInvoice: 'دارای پیش‌فاکتور/فاکتور',
  invoiceOrProformaInvoiceStatus: 'وضعیت پیش‌فاکتور/فاکتور',
  invoicePaymentDate: 'تاریخ پرداخت فاکتور',
  invoicePayment: 'پرداخت فاکتور',
  selectedCount: 'تعداد انتخاب شده',
  managementScore: 'کیفیت ارزیابی',
  ticketCounter: 'پیشخوان تیکت',
  basedOnDate: 'بر اساس تاریخ',
  basedOnUsers: 'بر اساس کاربران',
  basedOnTitles: 'بر اساس عنوان‌ها',
  basedOnFailureReasons: 'بر اساس دلایل شکست',
  basedOnSuccessReasons: 'بر اساس دلایل خرید',
  basedOnDepartment: 'بر اساس دپارتمان',
  basedOnSubjects: 'بر اساس موضوعات',
  basedOneEntrance: 'بر اساس درگاه ورودی',
  basedOnSLA: 'بر اساس SLA',
  basedOnLastConnectionResult: 'بر اساس نتیجه آخرین ارتباط',
  basedOnMediaName: 'بر اساس درگاه ورودی',
  ticketReport: 'گزارش تیکت',
  leadReport: 'گزارش سرنخ',
  ticketsReportBasedOnDate: 'گزارش تیکت ها بر اساس تاریخ',
  ticketsReportBasedOnUsers: 'گزارش تیکت ها بر اساس کاربران',
  ticketsReportBasedOnDepartment: 'گزارش تیکت ها بر اساس دپارتمان',
  ticketsReportBasedOnSubjects: 'گزارش تیکت ها بر اساس موضوعات',
  ticketsReportBasedOneEntrance: 'گزارش تیکت ها بر اساس درگاه ورودی',
  ticketsReportBasedOnSLA: 'گزارش تیکت ها بر اساس SLA',
  created: 'ایجاد شده',
  closed: 'بسته شده',
  closingRate: 'نرخ بستن',
  averageFirstResponseTime: 'میانگین زمان اولین پاسخ',
  averageClosingTime: 'میانگین زمان بستن',
  enterEntrance: 'درگاه ورودی',
  january: 'دی',
  february: 'بهمن',
  march: 'اسفند',
  april: 'فروردین',
  may: 'اردیبهشت',
  june: 'خرداد',
  july: 'تیر',
  august: 'مرداد',
  september: 'شهریور',
  october: 'مهر',
  november: 'آبان',
  december: 'آذر',
  reports: 'گزارش ها',
  report: 'گزارش',
  ticketsReport: 'گزارش تیکت ها',
  dealsReport: 'گزارش فرصت‌های فروش',
  tasksReport: 'گزارش وظیفه‌ها',
  assigned: 'اختصاص داده شده',
  statusChangeWasSuccessful: 'تغییر وضعیت با موفقیت انجام شد.',
  addToSubjects: 'افزودن به عنوان‌ها',
  deleteTask: 'حذف وظیفه',
  deleteTaskText: 'آیا از حذف وظیفه مطمئن هستید؟',
  deleteTaskSuccess: 'وظیفه باموفقیت حذف شد.',
  deleteProfile: 'حذف پروفایل',
  deletePeopleProfile: 'حذف پروفایل شخص',
  deletePeopleProfileText: 'آیا از حذف پروفایل شخص مطمئن هستید؟',
  deletePeopleProfileSuccess: 'پروفایل شخص باموفقیت حذف شد.',
  deleteCompanyProfile: 'حذف پروفایل شرکت',
  deleteCompanyProfileText: 'آیا از حذف پروفایل شرکت مطمئن هستید؟',
  deleteCompanyProfileSuccess: 'پروفایل شرکت باموفقیت حذف شد.',
  chatanswerd: 'این گفتگو توسط اپراتور دیگری پذیرفته‌شده است.',
  deletedUser: 'کاربر حذف شده',
  nameOrCallNumber: 'نام یا شماره تماس',
  sendOneTimePassword: 'ارسال رمز یکبار مصرف',
  sendPersonalizedText: 'ارسال متن شخصی‌سازی شده',
  selectYourTypeOfTemplate: 'نوع الگوی مورد نظر خود را انتخاب کنید',
  customerName: 'نام مشتری',
  templateId: 'شناسه الگو',
  templateType: 'نوع الگو',
  otp: 'رمز یک‌بار مصرف',
  personalizedtemplate: 'الگوی شخصی‌سازی شده',
  settings: 'تنظیمات',
  departement: 'دپارتمان',
  allDepartements: 'همه دپارتمان‌ها',
  allStatuses: 'همه وضعیت‌ها',
  allResults: 'همه نتیجه‌ها',
  allMediaNames: 'همه درگاه‌ها',
  userSettings: 'تنظیمات کاربری',
  noDepartmentExitsClickButtonBelowToCreateOne:
    'هنوز دپارتمانی ایجاد نشده است، برای ایجاد دپارتمان روی دکمه زیر کلیک کنید.',
  noDepartmentFound: 'دپارتمانی یافت نشد',
  departmentName: 'نام دپارتمان',
  departmentManager: 'مدیر دپارتمان',
  departmentKey: 'شناسه دپارتمان',
  uniqueKeyHintForDepartment:
    'شناسه برای هر دپارتمان یکتا است. بدون فاصله و با حروف انگلیسی وارد کنید.',
  selectingUsers: 'انتخاب کاربران',
  hasBeenSelected: 'انتخاب شده',
  searchNameUsernameUsernumber: 'جستجوی نام، نام کاربری، شماره کاربر',
  role: 'نقش',
  agreeToDeleteDepartment: 'آیا از حذف دپارتمان {item} مطمئن هستید؟',
  deletingDepartment: 'حذف دپارتمان',
  addingMember: 'افزودن عضو',
  deletingMember: 'حذف عضو',
  agreeToDeleteMember: 'آیا از حذف عضو {item} مطمئن هستید؟',
  searchDepartmentNameDescription: 'جستجوی نام، توضیحات دپارتمان',
  member: 'عضو',
  checkoutMembersDetail: 'مشاهده جزئیات اعضا',
  createLead: 'ایجاد سرنخ',
  addToPeopleAndCompany: 'افزودن به شخص /شرکت موجود',
  createNewPeopleAndCompany: 'ایجاد شخص /شرکت جدید',
  descriptionLead: 'توضیحات سرنخ',
  descriptionCall: 'توضیحات تماس',
  createFollowUpTask: 'ایجاد وظیفه پیگیری',
  leadCreatedSuccessfully: 'سرنخ با موفقیت ایجاد شد',
  leadView: 'مشاهده سرنخ',
  dealView: 'مشاهده فرصت فروش',
  newContactAdded: 'ایجاد شخص/شرکت جدید',
  actionSuccess: 'عملیات با موفقیت انجام شد.',
  actionFailed: 'مشکلی پیش آمده',
  viewProfile: 'مشاهده پروفایل',
  phoneCallOther: 'شماره تماس سایر ',
  submit: 'ثبت',
  callSounds: 'صوت‌های تماس',
  downloadAudioConversations: 'دانلود صوت‌ مکالمات',
  downloadAllAudioSConversations: 'دانلود همه صوت‌های تماس',
  yesDownload: 'بله، دانلود',
  deleteConversations: 'حذف صوت مکالمات',
  deleteAllConversationsAudio: 'حذف همه‌ی صوت‌های تماس',
  areyousureyouwanttoactionallentitynamefromtodate:
    'آیااز {action} همه {entityName} از تاریخ {from} تا تاریخ {to} مطمئن هستید؟',
  memberDeletedSuccessfully: 'عضو با موفقیت حذف شد.',
  insufficientFunds: 'عدم موجودی کافی',
  departmentMemberAddedSuccessfully: 'اعضای دپارتمان با موفقیت اضافه شد.',
  departmentAddedSuccessfully: 'دپارتمان با موفقیت اضافه شد.',
  departmentUpdatedSuccessfully: 'دپارتمان با موفقیت ویرایش شد.',
  departmentDeletedSuccessfully: 'دپارتمان با موفقیت حذف شد.',
  creatingNewContact: 'ایجاد مخاطب جدید',
  downloading: 'در حال دانلود',
  uploading: 'در حال آپلود',
  downloaded: 'دانلود شده‌ها',
  downloadsWereSuccessful: 'دانلودها با موفقیت انجام شد.',
  saveInArchive: 'ذخیره در آرشیو',
  disconnectedByOperator: 'قطع توسط اپراتور',
  busy: 'اشغال',
  reject: 'ریجکت',
  noAnswer: 'بدون پاسخ',
  callFile: 'فایل تماس',
  noPoll: 'بدون نظرسنجی',
  notFoundCall: 'تماسی یافت نشد.',
  qas: 'ارزیابی کیفیت',
  companyAgent: 'نماینده شرکت',
  submitCallDescription: 'ثبت توضیحات تماس',
  submitTicket: 'ثبت تیکت',
  proFormaInvoice: 'فاکتور/ پیش‌فاکتور',
  toCallClickButton: 'برای برقراری تماس، روی دکمه تماس کلیک کنید.',
  profile: 'پروفایل',
  followingContactsRegisteredWithContactNumber:
    'مخاطبین زیر با این شماره تماس ثبت شده اند',
  followingCompaniesRegisteredWithContactNumber:
    'شرکت های زیر با این شماره تماس ثبت شده اند',
  seeAll: 'مشاهده همه',
  noStartWithNumberIsAllowed: 'شناسه نمیتواند با عدد شروع شود.',
  userNotFound: 'کاربر مورد نظر یافت نشد',
  yourUserInfoIsNotComplete: 'اطلاعات کاربری شما کامل نمی‌باشد',
  addNewNumber: 'افزودن شماره جدید',
  other: 'سایر',
  otherNumberAddedSuccessfully: 'افزودن شماره با موفقیت انجام شد',
  otherNumberUpdateSuccessfully: 'ویرایش شماره‌های سایر با موفقیت انجام شد',
  otherNumberDeletedSuccessfully: 'حذف شماره‌های سایر با موفقیت انجام شد',
  callList: 'فهرست تماس',
  duplicateIvr: 'داخلی مورد نظر در صف وجود دارد',
  evaScore: 'امتیاز ارزیابی',
  overview: 'نمای کلی',
  noDealCreatedForThisProfile: 'فرصت فروش برای این پروفایل ایجاد نشده است!',
  nextFollowupTask: 'وظیفه‌ بعدی',
  latestTicket: 'آخرین تیکت',
  noTicketSubmittedForThisProfile: 'تیکتی برای این پروفایل ثبت نشده است!',
  noTaskSubmittedForThisProfile: 'وظیفه‌ای برای این پروفایل ثبت نشده است!',
  noCallSubmittedForThisProfile: 'تماسی برای این پروفایل ثبت نشده است!',
  latestDeal: 'آخرین فرصت فروش',
  latestCall: 'آخرین تماس',
  enterpriseDid: 'ورودی',
  enterpriseOut: 'خروجی',
  incoming: 'ورودی',
  outgoing: 'خروجی',
  divert: 'دایورت',
  internal: 'داخلی',
  unknown: 'نامشخص',
  noDescriptionSubmitted: 'توضیحی ثبت نشده',
  thereIsNoFile: 'فایل موجود نیست',
  nameCompanyRepresentative: 'نام نماینده شرکت',
  lastNameCompanyRepresentative: 'نام خانوادگی نماینده شرکت',
  description: 'توضیحات',
  manageRoleAndPermission: 'مدیریت نقش‌ و دسترسی‌',
  editRoleAndPermission: 'ویرایش نقش‌ و دسترسی‌',
  noRoleFound: 'نقشی یافت نشد',
  createNewRole: 'ایجاد نقش جدید',
  enterRoleNameAndDescription: 'ورود نام نقش و توضیحات',
  enterRoleNameInEnglish: 'نام نقش را به انگلیسی وارد کنید',
  copyFromOtherRoleAndCustomizeIt: 'کپی از نقش‌ دیگر و شخصی‌سازی آن',
  determineAccessLevelsAndPermissions: 'تعیین اختصاصی سطوح و حقوق دسترسی',
  selectWayToDetermineAccess: 'شیوه تعیین دسترسی‌ها را انتخاب کنید',
  selectDefaultRole: 'نقش پیش‌فرض را انتخاب کنید',
  reset: 'بازنشانی',
  selectAccessLevelsAndPermissions: 'انتخاب سطوح و حقوق دسترسی',
  saveNewRole: 'ذخیره نقش جدید',
  searchingFeature: 'جستجوی ویژگی',
  deleteAll: 'حذف همه',
  selectAccessLevel: 'سطح دسترسی را انتخاب کنید',
  nonSelectable: 'غیرقابل انتخاب',
  roleAddedSuccessfully: 'نقش با موفقیت اضافه شد.',
  roleUpdatedSuccessfully: 'نقش با موفقیت ویرایش شد.',
  fileTypeText: 'نوع فایل برای بارگذاری را انتخاب کنید:',
  manageRolesAndPermissions: 'مدیریت نقش و دسترسی',
  accessLevelAndRights: 'سطوح و حقوق دسترسی',
  noDealSubmittedForThisProfile: 'برای این پروفایل، فرصت فروش ثبت نشده است!',
  noLeadSubmittedForThisProfile: 'برای این پروفایل، سرنخ ثبت نشده است!',
  noContactSubmittedForThisProfile: 'برای این پروفایل، مخاطبی ثبت نشده است!',
  noAttachmentsSubmittedForThisProfile:
    'برای این پروفایل، مخاطب مرتبط ثبت نشده است!',
  noIdentityDocumentsSubmittedForThisProfile:
    'برای این پروفایل، مدارک هویتی ثبت نشده است!',
  searchNameOrLastnameOrNumberOrBusiness:
    'جستجوی نام، نام خانوادگی، شماره‌ تماس اصلی و نام کسب‌وکار',
  searchNameOrLastnameOrNumber: 'جستجوی نام، نام خانوادگی و شماره‌ تماس اصلی ',
  searchCompanyNameOrNumber: 'جستجوی نام شرکت، شماره تماس اصلی',
  fileIsLoading: 'فایل در حال بارگذاری است',
  filecouldnotbeuploaded: 'فایل آپلود نشد',
  youDontHavePermissionToDoThisAction:
    'شما مجاز به انجام این عملیات در این رکورد نیستید. در صورت نیاز به دسترسی، لطفاً با مدیر سیستم تماس بگیرید.',
  youDontHavePermissionToDoSomeOfThisAction:
    'شما مجاز به انجام {number} رکورد از این عملیات‌ نیستید. در صورت نیاز به دسترسی، لطفاً با مدیر سیستم تماس بگیرید.',
  unauthorized: 'دسترسی غیرمجاز',
  companyAdvanceFilterPlaceholder:
    'ورود نام شرکت، نام، نام‌خانوادگی نماینده، ...',
  peopleAdvanceFilterPlaceholder: 'ورود نام، نام‌خانوادگی، شماره تماس یا آدرس',
  filecouldnotbeuploadedtooltip:
    'ورود نام شرکت، نام، نام‌خانوادگی نماینده، شماره تماس، کد اقتصادی، شناسه ملی، کد یکتا، آدرس، کلمه کلیدی یادداشت ',
  notAccessToFile: 'عدم دسترسی به فایل',
  voiceMailMessages: 'پیام‌های پیام‌گیر صوتی',
  deletingRole: 'حذف نقش',
  editDepartment: 'ویرایش دپارتمان',
  createDepartment: 'ایجاد دپارتمان',
  firstname: 'نام',
  firstName: 'نام',
  submitterOperator: 'کارشناس ثبت کننده',
  assignToGroup: 'اختصاص دادن گروهی',
  successAssignToGroup: 'اختصاص گروهی با موفقیت انجام شد',
  selectedNumber: 'تعداد انتخاب‌شده',
  peopleProfileHistory: 'تاریخچه پروفایل اشخاص',
  companiesProfileHistory: 'تاریخچه پروفایل شرکت ها',
  nextTask: 'وظیفه بعدی',
  otherNumbers: 'سایر شماره ها',
  new: 'جدید',
  noHistoryFound: 'تاریخچه ای یافت نشد',
  atleastOnePermissionIsRequired:
    'ذخیره نقش نیازمند اختصاص دادن حداقل یک دسترسی است.',
  warning: 'اخطار',
  viewAndEdit: 'مشاهده و ویرایش',
  noInvoiceSubmittedYet: 'هنوز فاکتور یا پیش‌فاکتوری ثبت نشده است.',
  noProductAddedYet: 'هنوز محصولی افزوده نشده است.',
  createInventoryByClickingTheButtonBelow:
    'برای ایجاد انبار روی دکمه زیر کلیک کنید.',
  sendNow: 'ارسال اکنون',
  did: 'سرشماره',
  callCost: 'هزینه تماس',
  fullCdrAdvancedFilterText: 'ورود نام یا شماره تماس مخاطب، توضیحات',
  enterHighestCallCost: 'ورود بیشترین هزینه تماس',
  enterLowestCallCost: 'ورود کمترین هزینه تماس',
  enterMinimumConversationDuration: 'ورود کمترین مدت مکالمه',
  enterMaximumConversationDuration: 'ورود بیشترین مدت مکالمه',
  checkShortestWaitingTime: 'ورود کمترین زمان انتظار',
  checkLongestWaitingTime: 'ورود بیشترین زمان انتظار',
  noInvoiceOrPreInvoiceYet: 'هنوز فاکتور یا پیش‌فاکتور ایجاد نشده است.',
  creatLead: 'ایجاد سرنخ',
  prefix: 'پیشوند',
  addUserPrefixPlaceholderText:
    'حداقل 4 کاراکتر شامل عدد یا حرف، (شماره بدون پیش شماره‌های کشورها و استان‌ها) وارد کنید',
  closingDate: 'تاریخ بسته شدن',
  selectCustomDate: 'انتخاب تاریخ دلخواه',
  noTaskCreatedYet: 'هنوز وظیفه ای ایجاد نشده است.',
  navanumber: 'نواتل',
  navauser: 'کاربر نواتل',
  ipphone: 'آی‌پی‌فون',
  departments: '‌دپارتمان‌ها',
  index: 'ردیف',
  members: 'اعضا',
  createdAtDate: 'تاریخ ایجاد',
  updatedAtDate: 'تاریخ به‌روزرسانی',
  actions: 'عملیات',
  position: 'سمت',
  joinedAtDate: 'تاریخ عضویت',
  dealTitle: 'عنوان فرصت فروش',
  noNotesYet: 'هنوز یادداشتی ثبت نشده است.',
  updateNoteSuccessfully: 'یادداشت با موفقیت ویرایش شد.',
  descriptionText: 'متن توضیحات',
  submitDescription: 'ثبت توضیحات',
  descriptionEdit: 'ویرایش توضیحات',
  descriptionDelete: 'حذف توضیحات',
  descriptionDeleteText: 'آیا از حذف توضیحات  مطمئن هستید؟',
  contactDetailsSuccessfullyRegistered: 'توضیحات تماس با موفقیت ثبت شد',
  contactDetailsSuccessfullyDeleted: 'توضیحات تماس با موفقیت حذف شد',
  contactDetailsSuccessfullyEdited: 'توضیحات تماس با موفقیت ویرایش شد',
  otpMissmatch: 'کد OTP مطابقت ندارد',
  actionDoneSuccessfully: 'عملیات با موفقیت انجام شد.',
  deleteNote: 'حذف یادداشت',
  deleteNoteText: 'آیا از حذف یادداشت مطمئن هستید؟',
  errorInCallDescription: 'خطا در ثبت یا ویرایش توضیحات تماس!',
  recovery: 'بازیابی ',
  doYouIgnoreUnsavedChanges: 'آیا تغییرات ذخیره نشده را نادیده می‌گیرید؟',
  youHaveUnsavedChangesInThisPageIfYouContinueWithoutSaving:
    'شما در این صفحه تغییرات ذخیره نشده‌ای دارید که در صورت ادامه بدون ذخیره، از بین می‌روند.',
  noCancel: 'نه، لغو',
  yesExit: 'بله خروج',
  enterCallNumber: 'شماره تماس را وارد کنید',
  exitFromArchive: 'خروج از آرشیو',
  editPreInvoice: 'ویرایش پیش‌فاکتور',
  createPreInvoice: 'ایجاد پیش‌فاکتور',
  createInvoice: 'ایجاد فاکتور',
  evokeInvoice: 'ابطال فاکتور',
  campgainInfo: 'اطلاعات کمپین',
  utmsource: 'منبع ترافیک',
  utmcampaign: 'نام کمپین',
  utmcontent: 'محتوای تبلیغاتی',
  utmmedium: 'نوع رسانه',
  ip: 'نشانی آی‌پی',
  incomingpage: 'صفحه ورودی',
  majorType: 'نوع فعالیت',
  majorSubDomain: 'زیرحوزه فعالیت',
  table: 'جدول',
  chart: 'نمودار',
  smsSRSearchInputText: 'جستجو موضوع، متن، شناسه ارسال',
  sendType: 'نوع ارسال',
  sent: 'ارسال شده',
  readyToSend: 'آماده ارسال',
  canceled: 'لغو شده',
  sending: 'در حال ارسال',
  otpSend: 'ارسال otp',
  groupSend: 'ارسال گروهی',
  submissionId: 'شناسه ارسال',
  delivered: 'تحویل‌شده',
  notDelivered: 'تحویل‌نشده',
  webServiceError: 'خطای وب‌سرویس',
  wasNotFound: 'پیدا نشده',
  rejected: 'ریجکت شده',
  failedSend: 'ارسال ناموفق',
  contactsNumber: 'تعداد مخاطبین',
  submissionsTotalNumber: 'تعداد کل ارسال‌ها',
  shipmentsTotalCost: 'هزینه کل ارسال‌ها',
  totalReturnCost: 'مجموع هزینه بازگشتی',
  inSendQueue: 'در صف ارسال',
  submissionSuccessRate: 'نرخ موفقیت ارسال',
  distributingStatusMessages: 'توزیع وضعیت پیام‌ها',
  toman: 'تومان',
  searchIn: 'جستجو در',
  searchInCampaignData: 'جستجو در اطلاعات کمپین',
  searchInCampaignDataPlaceholder:
    'منبع ترافیک، نام کمپین، محتوای تبلیغاتی، نوع رسانه، صفحه ورودی',
  addMajorType: 'ثبت نوع فعالیت',
  buyerName: 'نام خریدار',
  sendSMS: 'ارسال پیامک',
  sendByWhatsapp: 'ارسال با واتساپ',
  selectCustomer: 'خریدار را انتخاب کنید',
  copyDownloadLink: 'کپی لینک دانلود',
  saveAndBillingPreInvoice: 'ذخیره و ارسال پیش‌فاکتور',
  noZeroQuantityAccepted: 'مقدار 0 برای محصول مجاز نیست.',
  itIsNecessaryToSelectAtLeastOneProduct: 'انتخاب حداقل یک محصول ضروری است.',
  error: 'خطا',
  selectADeviceFirst: 'ابتدا یک دستگاه انتخاب کنید',
  selectOneOrAddOne: 'یک مورد انتخاب یا اضافه کنید',
  addToDealTitles: 'افزودن به عناوین فرصت فروش',
  ticketArchivedFilteredEmptyState: 'تیکت آرشیو شده‌ای یافت نشد',
  ticketArchivedEmptyState: 'تیکت آرشیو شده‌ای وجود ‌ندارد',
  serial: 'سریال',
  phonebook: 'دفترچه تلفن',
  contacts: 'مخاطبین',
  groups: 'گروه‌ها',
  group: 'گروه',
  submitAndAddNext: 'ثبت و افزودن بعدی',
  lastName: 'نام‌خانوادگی',
  male: 'مرد',
  female: 'زن',
  dateOfRegistration: 'تاریخ ثبت',
  deleteContacts: 'حذف مخاطبین',
  successDeleteContact: 'مخاطب با موفقیت حذف شد.',
  successDeleteContacts: 'مخاطبین با موفقیت حذف شدند.',
  addGroup: 'افزودن گروه',
  editGroup: 'ویرایش گروه',
  groupName: 'نام گروه',
  editContact: 'ویرایش مخاطب',
  searchGroupName: 'جستجوی نام گروه',
  selectContacts: 'انتخاب مخاطبین',
  editGroupName: 'ویرایش نام گروه',
  editMembers: 'ویرایش اعضا',
  addMember: 'افزودن عضو',
  selectContact: 'انتخاب مخاطب',
  addToGroup: 'افزودن به گروه',
  allContacts: 'کل مخاطبین',
  notAddContactBlankPage:
    'هنوز مخاطبی اضافه نشده است، برای افزودن مخاطب از روش های زیر اقدام نمایید.',
  searchNameAndPhonesSmsContacts: 'جستجوی نام، نام خانوادگی، شماره های مخاطب',
  disapproved: 'رد شده',
  statusMessage: 'وضعیت پیام',
  unread: 'خوانده نشده',
  hasBeenRead: 'خوانده شده',
  unreadmessages: 'پیامک‌های خوانده نشده',
  totalNumberReceipts: 'تعداد کل دریافت‌ها',
  unreadNumber: 'تعداد خوانده نشده',
  smsReceiveReportSearchText: 'جستجوی شماره مخاطب',
  deleteGroup: 'حذف گروه',
  deleteGroups: 'حذف گروه ها',
  successDeleteGroup: 'گروه با موفقیت حذف شد.',
  successDeleteGroups: 'گروه ها با موفقیت حذف شدند.',
  selectedGroupCount: 'تعداد گروه انتخاب شده',
  selectedGroupContacts: 'انتخاب گروه مخاطبین',
  createdAtOrder: 'تاریخ‌ایجاد',
  updatedAtOrder: 'آخرین‌به‌روزرسانی',
  priorityOrder: 'اولویت سفارش',
  ascCreate: 'قدیمی‌ترین',
  descCreate: 'جدیدترین',
  ascTask: 'نزدیکترین',
  descTask: 'دورترین',
  ascPriority: 'پایین‌ترین',
  descPriority: 'بالاترین',
  ascUpdate: 'قدیمی‌ترین',
  descUpdate: 'جدیدترین',
  textIsSaved: 'ذخیره شده است',
  ascPrice: 'بیشترین',
  descPrice: 'کمترین',
  orderByCreateTime: 'تاریخ‌ایجاد',
  orderByNextFollowup: 'فعالیت‌آتی',
  orderByPrice: 'قیمت',
  orderByUpdateAt: 'تاریخ‌بروزرسانی',
  noContactHasBeenCreated: 'هنوز مخاطبی ایجاد نشده',
  noGroupHasBeenCreated: 'هنوز گروهی ایجاد نشده',
  contactNotFound: 'مخاطبی یافت نشد',
  typeAtLeastThreeChars: 'حداقل 3 کاراکتر وارد کنید',
  searching: 'در حال جستجو...',
  unifiedContactSearchPlaceholder:
    'جستجوی نام شخص یا شرکت، شماره‌های تماس و ...',
  saveAndAddNext: 'ثبت و افزودن بعدی',
  groupNotFound: 'گروهی یافت نشد',
  missedCalls: 'تماس‌های از دست‌رفته',
  callDate: 'تاریخ تماس',
  missedCallsSearchText: 'ورود نام یا شماره تماس مخاطب',
  makeCall: 'برقراری تماس',
  chosen: 'انتخاب شده',
  staticMessageServiceAlert:
    'محدودیت سرویس‌های پنل شما در آستانه رسیدن به سقف مجاز هستند. برای مشاهده جزئیات ',
  clicked: 'اینجا کلیک کنید',
  excessiveAlert: 'هشدار محدودیت‌',
  disconnectionReason: 'دلیل قطع تماس',
  chooseExpireDate: 'انتخاب تاریخ انقضا',
  afterSendingPreInvoiceAt: 'پس از ارسال پیش‌فاکتور در تاریخ',
  failReason: 'دلیل شکست',
  buyReason: 'دلیل خرید',
  addToList: 'افزودن به لیست',
  successReasonDescription: 'توضیحات دلیل خرید',
  failureReasonDescription: 'توضیحات دلیل شکست',
  noCaseFound: 'موردی یافت نشد',
  providingExplanations: 'ارائه توضیحات',
  ticketClosed: 'تیکت بسته‌شده',
  hasActiveTicket: 'دارای تیکت فعال',
  taskCompleted: 'وظیفه انجام‌شده',
  taskScheduled: 'دارای وظیفه برنامه‌ریزی‌شده',
  proformaInvoiceExpiration: 'انقضای ‌فاکتور',
  invoiceCanceledRefund: 'ابطال فاکتور - عودت وجه',
  chatAnswered: 'این گفتگو پاسخ داده شده است',
  convertedToContact: 'تبدیل شده به مخاطب',
  changedTheStatusOfThisConversationToEnd:
    'این گفتگو را به وضعیت پایان‌یافته تغییر داد',
  unsuccessfulDeal: 'فرصت فروش ناموفق',
  successfulDeal: 'فرصت فروش موفق',
  activeDeal: 'فرصت فروش فعال',
  meetingHeld: 'برگزاری جلسه',
  missedIncomingCall: 'تماس ورودی - از دست‌رفته',
  contactCanceled: 'انصراف مخاطب',
  callbackRequired: 'نیاز به تماس مجدد',
  loyalCustomer: 'مشتری وفادار',
  customer: 'مشتری',
  linkedin: 'لینکدین',
  marketingQualified: 'دارای شرایط بازاریابی',
  outgoingCallBusy: 'تماس خروجی - اشغال',
  outgoingCallNoAnswer: 'تماس خروجی - بدون پاسخ',
  birthDate: 'تاریخ تولد',
  followupOperator: 'کارشناس پیگیری',
  tags: 'برچسب ها',
  deleter: 'حذف کننده',
  trash: 'زباله',
  connection: 'ارتباط',
  registrationDate: 'تاریخ ثبت موفق/ناموقق',
  invoices: 'فاکتورها',
  result: 'نتیجه',
  businessActivity: 'فعالیت کسب وکار',
  businessActivityTree: 'درختواره فعالیت کسب وکار',
  transaction: 'معامله',
  positionInBusiness: 'سمت در کسب و کار',
  appraiserNumber: 'شماره ارزیابی کننده',
  appraiserName: 'نام ارزیابی کننده',
  evaluationPeriod: 'مدت زمان ارزیابی',
  descriptionSecondAssessment: 'توضیحات ارزیابی دوم',
  managerNumber: 'شماره مدیر',
  managerName: 'نام مدیر',
  managerDescription: 'توضیحات مدیر',
  operatorDescription: 'توضیحات اپراتور',
  firstEvaluationDescription: 'توضیحات اولین ارزیابی',
  companyId: 'شناسه شرکت',
  communicationPortalDeacon: 'شناسه درگاه ارتباطی',
  trackingCode: 'کد رهگیری',
  reference: 'رفرنس',
  saved: 'ذخیره شده',
  allocator: 'اختصاص دهنده',
  converter: 'تبدیل کننده',
  conversionDate: 'تاریخ تبدیل',
  transactionTitle: 'عنوان معامله',
  failExplanation: 'توضیح شکست',
  successReason: 'دلیل موفقیت',
  successExplanation: 'توضیح موفقیت',
  selectYear: 'انتخاب سال',
  contactsHistoryWasEdited: 'را ویرایش کرد',
  contactsHistoryWasCreated: 'را ایجاد کرد',
  exDeleteContactProfileSectionOne: 'آیا از حذف پروفایل',
  exDeleteContactProfileSectionTow: 'مطمئن هستید؟',
  exDeleteGroupContactProfileSectionOne: 'آیا از حذف',
  exDeleteGroupContactProfileSectionTow: 'پروفایل انتخاب‌شده مطمئن هستید؟',
  wasSuccessfullyDeleted: 'با موفقیت حذف شد',
  profileWasSuccessfullyDeleted: 'پروفایل با موفقیت حذف شد',
  exDeleteNoteSectionOne: 'آیا از حذف',
  exDeleteNoteSectionTwo: 'مطمئن هستید؟',
  expired: 'منقضی شده',
  planned: 'برنامه‌ریزی شده',
  oneDayBefore: 'یک روز قبل',
  anHourAgo: 'یک ساعت قبل',
  thirtyMinutesAgo: '30 دقیقه قبل',
  and: 'و',
  notDone: 'انجام نشده',
  exDeleteTaskSectionOne: 'آیا از حذف وظیفه',
  exDeleteTaskSectionTwo: 'با کد',
  exDeleteTaskSectionThree: 'مطمئن هستید؟',
  editTaskErrorOne:
    'با توجه به تاریخ انجام، وضعبت برنامه ریزی شده قابل انتخاب نیست',
  editTaskErrorTwo: 'وظیفه منقضی شده است باید تاریخ را از گذشته انتخاب کنید',
  editTaskErrorThree:
    'وظیفه انجام شده است باید تاریخ را از گذشته یا امروز انتخاب کنید',
  requiredField: 'پر کردن این فیلد اجباری است.',
  requiredSelect: 'انتخاب یک مورد اجباری است.',
  onlyEnglishIsAllowed: 'تنها حروف انگلیسی مجاز می‌باشد.',
  onlyEnglishNumbersIsAllowed: 'تنها اعداد انگلیسی مجاز می‌باشد.',
  noZeroIsAllowed: 'مقدار نمی‌تواند صفر باشد.',
  exactLength: '{length} کاراکتر وارد کنید.',
  minLength: 'حداقل {length} کاراکتر وارد کنید.',
  maxLength: 'حداکثر {length} کاراکتر وارد کنید.',
  maxValue: 'مقدار وارد شده نمی‌تواند بیشتر از {length} باشد.',
  confirmNotMatch: 'مقدار وارد شده با تکرار آن برابر نیست.',
  invalidValue: 'مقدار وارد شده معتبر نیست.',
  invalidEmail: 'ایمیل وارد شده معتبر نیست.',
  invalidPhone: 'شماره تماس وارد شده معتبر نیست.',
  nationalCodeLength: 'کد ملی باید ۱۰ رقم باشد.',
  nationalCodeSameDigits: 'کد ملی نمی‌تواند از ۱۰ رقم یکسان تشکیل شده باشد.',
  nationalCodeInvalid: 'کد ملی معتبر نیست.',
  dashNotAllowed: "امکان استفاده از کاراکتر ' - ' وجود ندارد.",
  spaceNotAllowed: 'امکان استفاده از کاراکتر فاصله وجود ندارد.',
  charactersNotAllowed: 'امکان استفاده از کاراکتر {chars} وجود ندارد.',
  noNumberInclude: 'امکان استفاده از عدد وجود ندارد.',
  bannedWordNotAllowed: 'امکان استفاده از "{word}" وجود ندارد.',
  invalidPhoneNumber: 'شماره تلفن وارد شده معتبر نیست',
  invalidInternationalMobileLengthMustBe11Digits:
    'طول شماره تلفن همراه بین‌المللی نامعتبر است (باید 11 رقمی باشد)',
  invalidMobileLengthMustBe11Digits:
    'طول شماره تلفن همراه نامعتبر است (باید 11 رقمی باشد)',
  invalidMobileWithoutZeroMustBe10Digits:
    'طول شماره تلفن همراه بدون صفر نامعتبر است (باید 10 رقمی باشد)',
  invalidPhoneFormat: 'فرمت شماره تلفن نامعتبر است',
  operatorNotFound: 'اپراتور شناسایی نشد',
  invalidLandlineLength7To13Digits:
    'طول شماره تلفن ثابت نامعتبر است (باید بین 7 تا 13 رقمی باشد)',
  invalidInternationalLandlineLength7To13Digits:
    'طول شماره تلفن ثابت بین‌المللی نامعتبر است (باید بین 7 تا 13 رقمی باشد)',
  provinceCodeNotFound: 'کد استان شناسایی نشد',
  wrong: 'اشتباه',
  irrelevant: 'بی ربط',
  normal: 'نرمال',
  unanswered: 'بی‌پاسخ',
  communicationPortFormatIsInvalid: 'فرمت درگاه ارتباطی نا متعبر است',
  idIsNotValid: 'شناسه معتبر نیست',
  mustHaveAtLeastThreeCharacters: 'حداقل سه کارکتر باید داشته باشد',
  fieldIsImpassable: 'فیلد نا متعبر است',
  lastNameCannotBeLongerThanValueCharacters:
    'نام خانوادگی نمیتواند بیشتر از {size} کاراکتر باشد',
  archiveCompletedSuccessfully: 'آرشیو با موفقیت انجام شد',
  kanban: 'کانبان',
  card: 'کارد',
  finalNegotiation: 'مذاکره نهایی',
  submitProposalProformaInvoice: 'ارائه پیشنهاد/پیش‌فاکتور',
  preliminaryNegotiations: 'مذاکرات اولیه',
  needsAssessmentAndAnalysis: 'ارزیابی و تحلیل نیاز',
  dollar: 'دلار',
  euro: 'یورو',
  pound: 'پوند',
  individual: 'حقیقی',
  legalEntity: 'حقوقی',
  dealSuccessfullyCreated: 'فرصت فروش با موفقیت ایجاد شد',
  dealEncounteredProblem: 'فرصت فروش با مشکل مواجه شد',
  errorReceivingStatusInformation: 'خطا در دریافت اطلاعات وضعیت ها',
  errorReceivingBoardInformation: 'خطا در دریافت اطلاعات بورد',
  errorReceivingCurrencyTypeInformation: 'خطا در دریافت اطلاعات نوع ارز',
  salesOpportunityInformation: 'اطلاعات فرصت فروش',
  default: 'پیش فرض',
  dealSuccessfullyDeleted: 'فرصت فروش با موفقیت حذف شد',
  dealSuccessfullyEdited: 'فرصت فروش با موفقیت ویرایش شد',
  errorEditingDeal: 'خطا در ویرایش فرصت فروش',
  errorDeletingDeal: 'خطا در حذف فرصت فروش',
  errorInReceivingDeal: 'خطا در دریافت فرصت فروش',
  errorInReceivingInvoiceListAndPreInvoice:
    'دریافت لیست فاکتور و پیش فاکتور با مشکل مواجه شد',
  contactDeleted: 'مخاطب حذف شده',
  lastTaskDate: 'تاریخ آخرین وظیفه',
  urgent: 'فوری',
  underReview: 'تحت بررسی',
  checked: 'بررسی شده',
  beingExamined: 'در حال بررسی',
  ticketNumber: 'شماره تیکت',
  expertRemoved: 'کارشناس حذف شده',
  review: 'بررسی',
  panel: 'پنل',
  positive: 'مثبت',
  negative: 'منفی',
  neutral: 'خنثی',
  deleteTaskConfirmPart1: 'آیا از حذف وظیفه',
  deleteTaskConfirmPart2: 'با کد',
  deleteTaskConfirmPart3: 'مطمئن هستید؟',
  startTime: 'زمان شروع',
  dueDate: 'مهلت انجام',
  paid: 'پرداخت شده',
  receivingFile: 'در حال دریافت فایل',
  pictures: 'تصاویر',
  inventoryStock: 'موجودی انبار',
  copiesNumber: 'تعداد نسخه',
  kilogram: 'کیلوگرم',
  gram: 'گرم',
  liter: 'لیتر',
  meter: 'متر',
  no_unit: 'بدون واحد اندازه گیری',
  shut: 'باز',
  pack: 'بسته',
  carton: 'کارتن',
  box: 'جعبه',
  set: 'ست',
  pair: 'جین',
  ton: 'تن',
  millimeter: 'میلی‌ متر',
  cubic_meter: 'مترمکعب',
  centimeter: 'سانتی‌متر',
  square_meter: 'مترمربع',
  milliliter: 'میلی‌لیتر',
  failureToCommunicate: 'عدم برقراری ارتباط',
  invalidInput: 'ورودی نامعتبر',
  uncertainNormal: 'عادی نامشخص',
  terminationByCustomer: 'قطع توسط مشتری',
  rejectTheCall: 'ریجکت تماس',
  diverty: 'دایورتی',
  answeredByAnotherOperator: 'پاسخ توسط اپراتور دیگر',
  incomingCallsNumber: 'تعداد تماس‌های ورودی',
  incomingCallTime: 'زمان تماس‌های ورودی',
  outgoingCallsNumber: 'تعداد تماس‌های خروجی',
  outgoingCallTimes: 'زمان تماس‌های خروجی',
  totalNumberOfConversations: 'مجموع تعداد مکالمات',
  totalConversationTime: 'مجموع زمان مکالمات',
  incomingCallResponseRate: 'درصد پاسخگویی تماس های ورودی',
  notTracked: 'پیگیری نشده',
  followingUp: 'در حال پیگیری',
  followedUp: 'پیگیری شده',
  cancelDownload: 'لغو دانلود',
  callsAnsweredNumber: 'تعداد تماس های پاسخ داده شده',
  missedCallsNumber: 'تعداد تماس های از دست رفته',
  averageTotalCallsNumber: 'میانگین تعداد تماس کل',
  averageTotalCalls: 'میانگین کل تماس ها',
  averageIncomingCallsNumber: 'میانگین تعداد تماس ورودی',
  averageOutgoingCallsNumber: 'میانگین تعداد تماس خروجی',
  averageOutgoingCalls: 'میانگین تماس های خروجی',
  averageIncomingCalls: 'میانگین تماس های ورودی',
  AverageCallsAnsweredNumber: 'میانگین تماس های پاسخ داده شده',
  queueSelection: 'انتخاب صف',
  deleteGroupSinglePrefix: 'آیا از حذف گروه ',
  deleteGroupSingleSuffix: ' مطمئن هستید؟',
  deleteGroupMultiplePrefix: 'آیا از حذف ',
  deleteGroupMultipleSuffix: ' گروه مطمئن هستید؟',
  deleteContactSinglePrefix: 'آیا از حذف مخاطب ',
  deleteContactSingleSuffix: ' مطمئن هستید؟',
  deleteContactMultiplePrefix: 'آیا از حذف ',
  deleteContactMultipleSuffix: ' مخاطب مطمئن هستید؟',
  addedSuccessfully: 'با موفقیت افزوده شد',
  editedSuccessfully: 'با موفقیت ویرایش شد',
  correspondingUniqueMessageText:
    'متن پیام منحصر بفرد هر شماره در اینجا نمایش داده می‌شود',
  notSelectedExcelFile: 'فایل انتخاب شده از نوع اکسل نیست',
  selectYourDesiredDate: 'تاریخ مورد نظر خود را انتخاب کنید',
  firstNameAndLastName: 'نام و نام خانوادگی',
  validityDate: 'تاریخ اعتبار',
  renewalDate: 'تاریخ تمدید',
  validityPeriod: 'مدت اعتبار',
  creditType: 'نوع اعتبار',
  recipients: 'دریافت کنندگان',
  reimbursement: 'بازگشت هزینه',
  dateAndTimeSending: 'تاریخ و زمان ارسال',
  submitted: 'ارسالی',
  details: 'جزییات',
  generalManager: 'مدیرکل',
  accountabilityExpert: 'کارشناس پاسخگویی',
  operatorNumber: 'شماره‌ اپراتور',
  allowedNumberDefinitions: 'امکان دسترسی به تعریف شماره مجاز',
  userSettingsManagement: 'تغییرات مدیریت یوزر',
  roleManagementAccess: 'دسترسی به مدیریت نقش',
  systemSettingsAccess: 'دسترسی به تنظیمات سامانه',
  conversationsDisplay: 'نمایش گفتگوها',
  persian: 'فارسی',
  english: 'انگلیسی',
  german: 'آلمانی',
  randomRoundRobinStrategy: 'استراتژی تصادفی با الگوریتم راند رابین',
  allOperatorsMessageStrategy: 'استراتژی دریافت پیام همه اپراتورها',
  leastReceivedMessageStrategy: 'استراتژی با کمترین دریافت کننده پیام',
  right: 'راست',
  left: 'چپ',
  evaluatedCallCount: 'تعداد تماس ارزیابی‌شده',
  averageEvaluationScore: 'میانگین نمره ارزیابی',
  averageSurveyScore: 'میانگین نمره نظرسنجی',
  private: 'خصوصی ',
  public: 'عمومی',
  navatelUsersUsernamePassword: 'کاربران نواتل (یوزرنیم پسورد)',
  numberLineStatus: 'وضعیت خط',
  crmType: 'نوع CRM',
  urlAddress: 'آدرس Url',
  selectiveCrm: 'CRM انتخابی',
  requestDate: 'تاریخ درخواست',
  answered: 'پاسخ داده شده',
  technical: 'فنی',
  financial: 'مالی',
  sales: 'فروش',
  you: 'شما',
  lastDay: 'روز گذشته',
  lastWeek: 'هفته گذشته',
  lastMonth: 'ماه گذشته',
  languageChange: 'تغییر زبان',
  ticketText: 'متن تیکت',
  responseToTicket: 'پاسخ به تیکت',
  less: 'کم',
  more: 'زیاد',
  refund: 'بازگشت وجه',
  featureRequest: 'درخواست فیچر',
  question: 'سوال',
  problem: 'مشکل',
  loading: 'در حال بارگذاری',
  ticketAllocation: 'اختصاص تیکت',
  yourCommentWasSuccessfullySubmitted: 'نظر شما با موفقیت ثبت شد',
  submittedSuccessfully: 'با موفقیت ارسال شد',
  transferred: 'منتقل‌شده',
  call: 'تماس‌',
  language: 'زبان',
  chooseLanguage: 'زبان را انتخاب کنید',
  itemHasAlreadyBeenAdded: 'این مورد قبلا اضافه شده است',
  phoneNumberEnteredIsDuplicate: 'شماره تلفن وارد شده تکراری است',
  selectAGroup: 'یک گروه انتخاب کنید',
  inaccessibilityToGroupList: 'عدم دسترسی به لیست گروه‌ها',
  evaluationInformationNotFound: 'اطلاعات ارزیابی یافت نشد',
  startCall: 'شروع تماس',
  identifyingCustomerNeeds: 'شناسایی نیاز های مشتری',
  maintainingProfessionalCourtesyAndCustomerInteraction:
    'رعایت ادب حرفه ای و تعامل با مشتری',
  suggestRightSolutionAndRecordProblem: 'پیشنهاد راه حل درست و ثبت مشکل',
  technicalSkills: 'مهارت های فنی',
  endCall: 'پایان تماس',
  dealSidebarMenu: 'فرصت فروش',
  invoicePreInvoiceSidebarMenu: 'فاکتور / پیش‌فاکتور',
  costHistoryChart: 'نمودار تاریخچه هزینه‌ها',
  groupSidebarMenu: 'گروهی',
  single: 'تکی',
  bulk: 'انبوه',
  corresponding: 'متناظر',
  parametric: 'پارامتریک',
  onceADay: 'روزی یک‌بار',
  onceAWeek: 'هفته‌ای یک‌بار',
  onceAMonth: 'ماهی یک‌بار',
  sendHour: 'ساعت ارسال',
  CUallowedRangeBetweenOneAndThree: '(بازه مجاز بین 1 تا 3)',
  companion: 'همراه',
  withinProvince: 'درون استانی',
  interProvincial: 'بین استانی',
  abroad: 'خارج از کشور',
  successfullyRegistered: 'با موفقیت ثبت شد',
  evaluationHasNotBeenRegistered: 'ارزیابی ثبت نشد',
  commentWasNotRegistered: 'نظر ثبت نشد',
  warehouseCreatedSuccessfully: 'انبار با موفقیت ایجاد شد',
  warehouseEditedSuccessfully: 'انبار با موفقیت ویرایش شد',
  productAddedSuccessfully: 'محصول با موفقیت اضافه شد',
  productUpdatedSuccessfully: 'محصول با موفقیت ویرایش شد',
  duplicateProduct: 'محصول تکراری است',
  productRemovedFromInventorySuccessfully: 'محصول با موفقیت از انبار حذف شد',
  productDeductedFromInventorySuccessfully: 'محصول با موفقیت از انبار خارج شد',
  inventoryDeletedSuccessfully: 'انبار با موفقیت حذف شد',
  dealForThisLead: 'برای این سرنخ فرصت فروش',
  leadToContact: 'این سرنخ را به مخاطب',
  selectInventoryManager: 'مدیر انبار را انتخاب کنید',
  CUInventoryNameMaxLengthCharacters: 'نام انبار باید کمتر از 20 کاراکتر باشد',
  languages: 'زبان ها',
  CUFrom: 'را از',
  representativeContactNumber: 'شماره تماس نماینده',
  '... created': 'را ایجاد کرد',
  '... updated': 'را ویرایش کرد',
  '... pinned': 'را پین کرد',
  '... assigned': 'را اختصاص داد',
  '... assignedAnotherOperator': 'را به کارشناس دیگری اختصاص داد',
  '... deleted': 'را حذف کرد',
  '... archived': 'را به آرشیو اضافه کرد',
  '... unarchived': 'را از آرشیو خارج کرد',
  '... converted': 'تبدیل کرد',
  '... revoked': 'را ابطال کرد',
  '... convertedToInvoice': 'را به فاکتور تبدیل کرد',
  '... repliedTo': 'را پاسخ داد',
  selectProduct: 'محصول را انتخاب کنید',
  inventoryCannotBeZero: 'موجودی نمی تواند صفر باشد',
  navatelNumbers: 'شماره های نواتل',
  kilometer: 'کیلومتر',
  attention: 'توجه',
  theEconomicCodeMustBeNumberOrNumberDigits:
    'کد اقتصادی باید {number1} تا {number2} رقم باشد',
  submitOffer: 'ارسال پیشنهاد',
  sendingPreInvoice: 'ارسال پیش‌فاکتور',
  leadToSales: 'منجر به فروش',
  deleteLead: 'حذف سرنخ',
  areYouSureToDeleteLead: 'آیا از حذف این سرنخ مطمئن هستید؟',
  areYouSureToDeleteNumberSelectedLeads:
    'آیا از حذف {number} سرنخ انتخاب شده مطمئن هستید؟',
  CULeadConvertedOpportunityCreated:
    'این سرنخ به مخاطب تبدیل شده است و یک فرصت‌ فروش برای آن ایجاد شده است',
  standardGreeting: 'بیان استاندارد آغاز مکالمه با رعایت سرعت و لحن مناسب',
  addressingByName: 'مخاطب قرار دادن مشتری با استفاده از نام در طی تماس',
  askingQuestions: 'پرسیدن سوال از مشتری برای فهمیدن مشکل (درک مطلب)',
  correctInfoGathering:
    'دریافت اطلاعات درست از مشترک جهت معرفی سرویس در راستای نیازمندی وی(شرکتی/شخصی و...)',
  correctAnswering:
    'ارائه پاسخ درست به سوالات مشتری/فهماندن منظور خود به مشتری',
  politeness:
    'مودب بودن، استفاده از لحن خوب-مخاطب قرار دادن مشتری با ضمیر جمع-ممانعت از صحبت با دیگران',
  buildingTrust: 'ایجاد احساس اعتماد به شرکت',
  empathyAndListening:
    'همدلی و تعامل، شمرده شمرده حرف زدن و عدم عجله، استفاده از زبان ساده، دارای مهارت گوش دادن',
  timeManagement: 'تناسب مدت زمان پاسخگویی (مدیریت زمان)',
  accurateInfo:
    'ارائه اطلاعات و خدمات طبق بخشنامه های اجرائی (مرتبط، صحیح و دقیق)',
  understandingNeed:
    'درک نیاز/خواسته/سوال مشتری و ایجاد اعتماد در مشترک از برطرف شدن آن',
  providingSolutions:
    'ارائه راه حل و گزینه های جایگزین (با به کارگیری کلیه منابع در دسترس)',
  problemSolving: 'حل مشکل مشتری (در صورت لزوم ثبت تیکت و اجرا به واحد دیگر)',
  handlingComplaint: 'شیوه مدیریت مکالمه هنگام اعلام نارضایتی از سوی مشترک',
  productKnowledge: 'دانش و مهارت مناسب در رابطه با محصول و سیستمها',
  ticketRecording: 'ثبت تیکت در صدای مشتری و تکمیل اطلاعات بر طبق استاندارد',
  correctReasonSelection: 'انتخاب صحیح دلیل تماس و ارجاع صحیح در صدای مشتری',
  holdManagement:
    'استفاده صحیح از حالت انتظار (اجازه گرفتن،اعلام زمان، توضیح دلیل) و پرهیز از سکوت نابجا درحین تماس',
  callSummary:
    'جمع بندی صحیح تماس و اطمینان از جامعیت پاسخگویی ( تشکر از تماس گیرنده) و اعلام مدت زمان پیگیری',
  callClosure:
    'رعایت استاندارد پایان تماس و تشویق مشتری جهت حفظ ارتباط با مرکز تماس و راهنمایی جهت شرکت در نظر سنجی',
  cellNumber: 'شماره همراه',
  selectTimeMinutesAndHours: 'زمان را انتخاب کنید(دقیقه/ساعت)',
  emailTo: 'ایمیل به ...',
  leadHistory: 'تاریخچه سرنخ',
  enterNewFieldTitle: 'عنوان فیلد جدید را وارد نمایید',
  addNewField: 'افزودن فیلد جدید',
  additionalInformation: 'اطلاعات تکمیلی',
  additionalInformationEdit: 'ویرایش اطلاعات تکمیلی',
  additionalInformationFieldsEdit: 'ویرایش فیلدهای اطلاعات تکمیلی',
  changesMadeFieldsBelowWillAppliedAllProfiles:
    'تغییرات ایجاد شده در فیلدهای زیر در تمام پروفایل‌های شما اعمال خواهد شد.',
  deleteField: 'حذف فیلد',
  areYouSureYouWantToDeletefild: 'آیااز حذف فیلد {item} مطمئن هستید؟',
  conversationWithContactHasNotYetStartedWhatsApp:
    'هنوز مکالمه‌ای با این مخاطب در واتس‌اپ آغاز نشده است.',
  anAmount: 'مبلغی',
  anPercent: 'درصدی',
  naturalPerson: 'شخص حقیقی',
  legalCompany: 'شرکت حقوقی',
  selectAutoCompletePlaceholder:
    'عنوان دلخواه را وارد یا از عناوین ثبت‌شده انتخاب کنید',
  ticketTitlePlaceholder: 'عنوان را وارد یا انتخاب کنید',
  addSalesOpportunityTitles: 'افزودن به عناوین فرصت فروش',
  areYouSureWantToDeleteTitle: 'از حذف این عنوان مطمئنید؟',
  registerNewTitle: 'ثبت عنوان جدید',
  ticketCreatedSuccessfully: 'تیکت با موفقیت ایجاد شد',
  noteOnceTicketClosedWarning:
    'توجه: پس از بستن تیکت، امکان تغییر ان وجود ندارد',
  ticketClose: 'بستن تیکت',
  ticketChangeStatusWarning: 'آیا از تغییر وضعیت تیکت به {item} مطمئن هستید؟',
  smsParametricSampleMessage:
    '<span>مشتری گرامی </span><span class="hashtag-highlight">#نام و نام‌خانوادگی#</span><span> تاریخ اعتبار شما تا </span><span class="hashtag-highlight">#تاریخ اعتبار#</span><span> است. لطفا برای تمدید تاریخ تا 30 اردیبهشت اقدام فرمایید.</span>',
  brokenDestination: 'مقصد خراب',
  timeToDo: 'زمان انجام',
  invoiceEmptyTitle: 'هنوز فاکتوری ایجاد نشده است.',
  label: 'برچسب',
  createLabel: 'ایجاد برچسب',
  addLabel: 'افزودن برچسب',
  newLabel: 'برچسب جدید',
  editLabel: 'ویرایش برچسب',
  labelName: 'نام برچسب',
  colorSelectionMandatory: 'انتخاب رنگ اجباری است',
  deleteLabel: 'حذف برچسب',
  areYouSureWantToRemoveFollowingTag:
    'آیا از حذف برچسب زیر از فهرست برچسب‌ها مطمئن هستید؟',
  archivedLeadEditDisabled: 'امکان ویرایش سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadCallDisabled: 'امکان ثبت تماس برای سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadTaskDisabled:
    'امکان ایجاد وظیفه برای سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadNoteDisabled:
    'امکان ثبت یادداشت برای سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadAssignDisabled:
    'امکان اختصاص دادن برای سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadAddToContactDisabled:
    'امکان افزودن سرنخ‌های آرشیو شده به مخاطبین وجود ندارد',
  archivedLeadSmsDisabled:
    'امکان ارسال پیامک برای سرنخ‌های آرشیو شده وجود ندارد',
  archivedLeadChangeStatusDisabled:
    'امکان تغییر وضعیت برای سرنخ‌های آرشیو شده وجود ندارد',
  automation: 'اتوماسیون',
  workflow: 'گردش کار',
  executionDate: 'تاریخ اجرا',
  workflowName: 'نام گردش‌کار',
  workflowType: 'نوع گردش‌کار',
  workflowStatus: 'وضعیت گردش‌کار',
  searchWorkflowName: 'جستجوی نام گردش‌کار',
  relatedModule: 'ماژول مرتبط',
  triggerType: 'نوع شروع',
  action: 'اقدام',
  executionCount: 'تعداد اجرا',
  autoSendSmsAfterCall: 'ارسال خودکار پیامک بعد از اتمام تماس',
  autoSendSmsAfterContactCreation: 'ارسال خودکار پیامک بعد از ثبت مخاطب در CRM',
  birthdayGreetingWorkflow: 'ارسال پیام تبریک تولد برای مخاطبین ثبت شده در CRM',
  eventBased: 'رویدادمحور',
  timeBased: 'زمان‌محور',
  workflowInformation: 'اطلاعات گردش‌کار',
  executionReports: 'گزارش اجراها',
  disableWorkflowFirst: 'ابتدا گردش‌کار را غیرفعال کنید',
  event: 'رویداد',
  lastExecution: 'آخرین اجرا',
  lastEdit: 'آخرین ویرایش',
  lastExecutionDate: 'تاریخ آخرین اجرا',
  workflowChangeHistory: 'تاریخچه تغییرات گردش‌کار',
  executionConditions: 'شرایط اجرا',
  executionType: 'نوع اجرا',
  eventModule: 'ماژول رویداد',
  condition: 'شرط',
  workflowExecutionReport: 'گزارش اجرای گردش‌کار',
  workflowExecution: 'اجرای گردش‌کار',
  exit: 'خروج',
  workflowExecutions: 'اجراهای گردش‌کار',
  eventDate: 'تاریخ رویداد',
  executionStatus: 'وضعیت اجرا',
  rerun: 'اجرای مجدد',
  saveAsInactive: 'ذخیره به صورت غیرفعال',
  editWorkflow: 'ویرایش گردش‌کار',
  selectWorkflowStartMethod: 'نحوه شروع گردش‌کار را انتخاب کنید.',
  selectEventModule: 'ماژول رویداد را انتخاب کنید',
  selectEvent: 'رویداد را انتخاب کنید',
  eventAccording: 'بر اساس رویداد',
  timeAccording: 'بر اساس زمان',
  port: 'درگاه',
  selectInlineVariableField: 'انتخاب فیلد متغیر درون‌متنی',
  inlineVariableFieldDescription:
    'برای شخصی‌سازی متن پیامک، می‌توانید فیلدهای هر مخاطب را انتخاب کرده و در متن پیامک استفاده کنید. همچنین هنگام تایپ، با فشردن کلید # می‌توانید فیلد متغیر موردنظر خود را انتخاب کنید.',
  field: 'فیلد',
  addCondition: 'افزودن شرط',
  selectModule: 'ماژول را انتخاب کنید',
  selectRepeatInterval: 'دوره تکرار را انتخاب کنید.',
  selectStartDate: 'تاریخ شروع را انتخاب کنید.',
  confirmExecution: 'بله، اجرا',
  confirmWorkflowActivationMessage: 'آیا از {action} «{title}» مطمئن هستید؟',
  reviewAndActivateWorkflow: 'بررسی و فعال‌سازی گردش‌کار',
  confirmActivate: 'بله، فعال',
  reviewAndDeactivateWorkflow: 'بررسی و غیرفعال‌سازی گردش‌کار',
  confirmDeactivate: 'بله، غیرفعال',
  deactivation: 'غیرفعال‌سازی',
  call_center: 'مرکز تلفن',
  send_sms: 'ارسال پیامک',
  completeRequiredConfigurationToActivateWorkflow:
    'برای فعال‌سازی این گردش کار، تنظیمات الزامی را تکمیل کنید.',
  noWorkflowExecutions: 'این گردش کار هنوز اجرایی نداشته است.',
  archivePreinvoice: 'آرشیو پیش‌فاکتور',
  archiveInvoice: 'آرشیو فاکتور',
  archivePreinvoiceConfirmation: 'آیا از آرشیو پیش‌فاکتور {item} مطمئن هستید؟',
  archiveInvoiceConfirmation: 'آیا از آرشیو فاکتور {item} مطمئن هستید؟',
  confirmArchive: 'بله، آرشیو',
  unarchivePreinvoice: 'خروج از آرشیو پیش‌فاکتور',
  unarchiveInvoice: 'خروج از آرشیو فاکتور',
  unarchivePreinvoiceConfirmation:
    'آیا از خروج از آرشیو پیش‌فاکتور {item} مطمئن هستید؟',
  unarchiveInvoiceConfirmation:
    'آیا از خروج از آرشیو فاکتور {item} مطمئن هستید؟',
  confirmUnarchive: 'بله، خروج از آرشیو',
  preinvoiceAndInvoice: 'پیش‌فاکتور و فاکتور',
  dealEmptyTitleArchived: 'فرصت فروش آرشیو شده‌ای وجود ندارد.',
  activitiesLog: 'تاریخچه تعاملات',
  activity: 'تعامل',
  activityStatus: 'وضعیت تعامل',
  noStatus: 'بدون تعامل',
  waitingFollowUp: 'در انتظار پیگیری',
  immediateFollowUp: 'پیگیری فوری',
  processed: 'رسیدگی شده',
  timeLineSearchText: 'جستجوی نام یا شماره مخاطب',
  updateTaskStatus: 'ویرایش وضعیت وظیفه',
  updateLeadStatus: 'ویرایش وضعیت سرنخ',
  convertLead: 'تبدیل سرنخ',
  receiveSMS: 'دریافت پیامک',
  ticketChangeStatus: 'تغییر وضعیت تیکت',
  convertingPreInvoice: 'تبدیل پیش‌فاکتور',
  paymentPreInvoice: 'پرداخت پیش‌فاکتور',
  changeDealStatus: 'تغییر وضعیت فرصت فروش',
  taskDeferral: 'تعویق وظیفه',
  taskDone: 'انجام وظیفه',
  inbound: 'دریافت',
  fail: 'ناموفق',
  expire: 'منقضی شده',
  evoke: 'بازیابی',
  convert: 'تبدیل',
  changeStatus: 'تغییر وضعیت',
  stepUpdate: 'تغییر وضعیت',
  unrelated: 'بی ربط',
  nostate: 'نامشخص',
  updateStatusLead: 'تغییر وضعیت سرنخ',
  viewActivities: 'مشاهده تعاملات',
  viewCommunicationHistory: 'مشاهده سوابق ارتباط',
  communicationHistory: 'سوابق ارتباط',
  relatedLeads: 'سرنخ‌های مرتبط',
  viewMoreDetails: 'مشاهده اطلاعات بیشتر',
  viewLessDetails: 'مشاهده اطلاعات کمتر',
  noRelatedLead: 'سرنخ مرتبطی یافت نشد',
  activitiesDate: 'تاریخ تعاملات',
  editTicket: 'ویرایش تیکت',
  update: 'ویرایش',
  previousStatus: 'وضعیت قبلی',
  viewDealProfile: 'مشاهده پروفایل فرصت فروش',
  viewTicketProfile: 'مشاهده پروفایل تیکت',
  noActivityFound: 'تعاملی یافت نشد',
  viewPreInvoice: 'مشاهده پیش‌فاکتور',
  viewInvoice: 'مشاهده ‌فاکتور',
  receivedSMS: 'پیامک دریافتی',
  sentSMS: 'پیامک ارسالی',
  noActivityHasBeenRecordedYet: 'هنوز تعاملی ثبت نشده است',
  incomingSuccessful: 'ورودی - موفق',
  outboundSuccessful: 'خروجی - موفق',
  incomingConnectionFailure: 'ورودی - عدم برقراری ارتباط',
  outboundConnectionFailure: 'خروجی - عدم برقراری ارتباط',
  incomingInvalidIncoming: 'ورودی - ورودی نامعتبر',
  outboundInvalidIncoming: 'خروجی - ورودی نامعتبر',
  incomingNoAnswer: 'ورودی - بدون پاسخ',
  outboundNoAnswer: 'خروجی - بدون پاسخ',
  incomingCallRejected: 'ورودی - ریجکت تماس',
  outboundCallRejected: 'خروجی - ریجکت تماس',
  incomingDisconnectedByCustomer: 'ورودی - قطع توسط مشتری',
  outboundDisconnectedByOperator: 'خروجی - قطع توسط اپراتور',
  incomingUnknownStandard: 'ورودی - عادی نامشخص',
  outboundUnknownStandard: 'خروجی - عادی نامشخص',
  incomingUserBusy: 'ورودی - اشغال',
  outboundUserBusy: 'خروجی - اشغال',
  cardNotFound: 'کارت پیدا نشد',
  createPeople: 'ایجاد شخص',
  createCompanies: 'ایجاد شرکت',
  representative: 'نماینده',
  peopleAndCompanies: 'اشخاص و شرکت‌ها',
  portalDeacon: 'شناسه درگاه',
  updateLead: 'ویرایش سرنخ',
  saveAsActive: 'ذخیره به صورت فعال',
  confirmWorkflowSaveAsActiveMessage:
    'آیا از ذخیره به صورت فعال {item} مطمئن هستید؟',
  selectAnActivity: 'تعامل را انتخاب کنید',
  lastUpdateDate: 'تاریخ آخرین بروزرسانی',
  completionDate: 'تاریخ انجام',
  duplicatePhoneNumber: 'این شماره تماس قبلا ثبت شده است.',
  duplicateProfilesFound: 'پروفایل‌های زیر با این شماره تماس ثبت شده اند',
  duplicatePhoneAlert: 'این شماره قبلا ثبت شده است.',
  noProfileAccess: 'شما دسترسی به مشاهده این پروفایل را ندارید!',
  moreActions: 'اقدامات بیشتر',
  addTag: 'افزودن برچسب',
  upgrade: 'به روزرسانی',
  upsert: 'افزودن و به روزرسانی',
  selectImportMethod: 'شیوه بارگذاری اطلاعات را انتخاب کنید:',
  uploadExampleHint: 'اطلاعات خود را طبق نمونه فایل وارد و سپس بارگذاری کنید:',
  rows: 'ردیف ها',
  uploadEncounteredProblem: 'پردازش فایل با چند خطا انجام شد.',
  incompleteUploadHintText:
    '{successCount} از {totalCount} ردیف با موفقیت به‌روزرسانی شدند. {failedCount} ردیف به دلیل خطا اعمال نشدند.',
  informationUpgradedSuccessfully: 'اطلاعات با موفقیت به‌روزرسانی شد.',
  uploadWasntDone: 'بارگذاری اطلاعات انجام نشد.',
  formatIsNotValidText:
    'فرمت یا ساختار فایل معتبر نیست. لطفاً فایل را بر اساس قالب نمونه اصلاح و دوباره بارگذاری کنید.',
  outputDownload: 'دانلود خروجی',
  downloadBasedOn: 'دانلود بر اساس',
  allFields: 'همه فیلدها',
  customization: 'شخصی سازی',
  notes: 'یادداشت ها',
  technicalInfo: 'اطلاعات فنی',
  ipAddress: 'آدرس آی‌پی',
  deviceType: 'نوع دستگاه',
  os: 'سیستم عامل',
  browser: 'مرورگر',
  appVersion: 'نسخه نرم‌افزار',
  customerSerial: 'سریال مشتری',
  agentFullName: 'نام و نام خانوادگی نماینده',
  representativePhoneNumber: 'شماره نماینده',
  representativeNationalId: 'کدملی نماینده',
  contactFullName: 'نام کامل مخاطب',
  secondaryPhone: 'شماره دوم',
  callQueueName: 'نام صف تماس',
  surveyScore: 'نمره نظرسنجی',
  uploadPngLogoHint: 'فرمت PNG، نسبت تصویر ۱:۱ (مربع)',
  uploadStampAndSignaturePngHint: 'فرمت PNG، نسبت تصویر ۲:۱ (افقی)',
  recurrenceInterval: 'دوره تکرار',
  bulkDeleteTasks: 'حذف گروهی وظیفه‌ها',
  bulkDeleteTasksConfirm: 'آیا از حذف وظیفه‌های انتخاب شده مطمئن هستید؟',
  taskDeletedSuccess: 'وظیفه با موفقیت حذف شد. | وظیفه‌ها با موفقیت حذف شدند.',
  createWorkflow: 'ایجاد گردش کار',
  callCenter: 'مرکز تماس',
  yearly: 'سالانه',
  selectField: 'فیلد را انتخاب کنید',
  chooseOperator: 'عملگر را انتخاب کنید',
  selectFieldValues: 'مقدارهای فیلد را انتخاب کنید',
  equals: 'برابر باشد با',
  notEquals: 'برابر نباشد با',
  contains: 'شامل شود',
  notContains: 'شامل نشود',
  startsWith: 'شروع شود با',
  endsWith: 'پایان یابد با',
  isEmpty: 'خالی باشد',
  isNotEmpty: 'خالی نباشد',
  before: 'قبل از',
  after: 'بعد از',
  between: 'در بازه باشد',
  notBetween: 'خارج از بازه باشد',
  greaterThan: 'بزرگتر باشد از',
  greaterThanOrEqual: 'بزرگتر یا مساوی باشد',
  lessThan: 'کوچکتر باشد از',
  lessThanOrEqual: 'کوچکتر یا مساوی باشد',
  deleteWorkflow: 'حذف گردش‌کار',
  confirmDeleteWorkflowWithWorkflow: 'آیا از حذف گردش‌کار {item} مطمئن هستید؟',
  workflowDeletedSuccessfully: 'گردش‌کار با موفقیت حذف شد.',
  workflowCreatedSuccessfully: 'گردش‌کار با موفقیت ایجاد شد.',
  workflowEditedSuccessfully: 'گردش‌کار با موفقیت ویرایش شد.',
  ticketTag: 'برچسب تیکت',
  ticketView: 'مشاهده تیکت',
  ticketHistory: 'تاریخچه تیکت',
  callRecording: 'ضبط مکالمات',
  abilityToRecordOutgoingCalls: 'امکان ضبط مکالمات تماس‌های خروجی',
  abilityRecordInternalInternalCalls:
    'امکان ضبط مکالمات تماس‌های داخلی به داخلی',
  callRatings: 'نظرسنجی تماس',
  outboundCallSurveyCapability: 'امکان نظرسنجی تماس خروجی',
  yes: 'بله',
  newest: 'جدیدترین',
  oldest: 'قدیمی ترین',
  order_by_create_time: 'تاریخ ایجاد',
  order_by_next_followup: 'فعالیت‌آتی',
  order_by_price: 'قیمت',
  order_by_update_at: 'تاریخ بروزرسانی',
  next_follow_up_date: 'فعالیت‌آتی',
  created_at_order: 'تاریخ ایجاد',
  updated_at_order: 'تاریخ بروزرسانی',
  priority_order: 'اولویت',
  highestPriority: 'بالاترین اولویت',
  lowestPriority: 'پایین‌ترین اولویت',
  mostExpensive: 'گران‌ترین',
  cheapest: 'ارزان‌ترین',
  assignToExpertLabel: 'اختصاص به کارشناس',
  selectTheDate: 'تاریخ را انتخاب کنید',
  selectFieldValue: 'مقدار فیلد را انتخاب کنید',
  enterFieldValue: 'مقدار فیلد را وارد کنید',
  module: 'ماژول',
  withoutCondition: 'بدون شرط',
  boards: 'بوردها',
  numberOfRules: 'تعداد قوانین',
  numberOfStatus: 'تعداد وضعیت',
  boardRules: 'قوانین بورد',
  boardName: 'نام بورد',
  createBoard: 'ایجاد بورد',
  copyBoard: 'کپی بورد',
  deleteBoardItem: 'حذف بورد {item}',
  deleteBoard: 'حذف بورد',
  deleteBoardConfirm: 'آیا از حذف کردن بورد {item} مطمئن هستید؟',
  deleteBoardWarning: 'این عملیات قابل بازگشت نیست.',
  boardDeletedSuccessfully: 'بورد با موفقیت حذف شد.',
  copyFromBoard: 'کپی از بورد',
  boardWantToCopyFrom: 'بوردی که می‌خواهید از آن کپی کنید',
  backToBoardsList: 'بازگشت به فهرست بوردها',
  configuration: 'پیکربندی',
  rules: 'قوانین',
  sorting: 'مرتب‌سازی',
  stateName: 'نام وضعیت',
  color: 'رنگ',
  closedOrOpen: 'بسته یا باز',
  ticketCount: 'تعداد تیکت',
  statuses: 'وضعیت‌ها',
  selectTheColor: 'رنگ را انتخاب کنید',
  editedItemsCount: 'تعداد موارد ویرایش شده',
  confirmDeleteBoard: 'آیا از حذف برد "{item}" مطمئن هستید؟',
  boardCannotBeDeletedWarning:
    'این برد قابل حذف نیست زیرا در حال حاضر حاوی رکوردهایی است و/یا در حال استفاده است. لطفاً جدول پیکربندی را برای بررسی و حذف هرگونه کاربرد مرتبط بررسی کنید.',
  defaultStatus: 'وضعیت‌ پیش‌فرض',
  selectDefaultStatusWhichRecordsCreated:
    'انتخاب کنید که رکوردهای جدید به طور پیش‌فرض در کدام وضعیت ایجاد شوند',
  usersCanOnlyCreateWarning:
    'کاربران فقط می‌توانند در وضعیت‌های انتخاب شده، تیکت جدید ایجاد کنند.',
  ticketsCannotSelectSelectedStatuses:
    'تیکت‌ها نمی‌توانند وضعیت‌های انتخاب‌شده را رد کنند.',
  otherStatuses: 'وضعیت‌های دیگر',
  selectStatuses: 'وضعیت‌ها را انتخاب کنید',
  ticketsCannotMoveBackward:
    'تیکت‌ها نمی‌توانند از وضعیت‌های انتخاب‌شده به عقب حرکت کنند',
  limitRolesCanEditTicketsInSelectedStatus:
    'محدود کردن نقش‌هایی که می‌توانند تیکت‌ها را در وضعیت انتخابی ویرایش کنند',
  selectWhichRolesCanEditTicketsInEachStatus:
    'انتخاب کنید چه نقش‌هایی می‌توانند تیکت‌ها را در هر وضعیت ویرایش کند',
  ticktSettingsRulesTableWarningText:
    'توجه: این قوانین هنگام ایجاد یا ویرایش تیکت‌ها در بوردها و همچنین برای مدیران ارشد یا کاربرانی که مجوز ویرایش تنظیمات ویژگی را دارند، اعمال نمی‌شود.',
  ticketSettings: 'تنظیمات تیکت',
  returnToTickets: 'بازگشت به تیکت‌ها',
  addStatus: 'افزودن وضعیت',
  ticketsRequireApprovalReachFollowingStatuses:
    'تیکت‌ها پس از رسیدن به وضعیت‌های زیر، نیاز به تأیید خواهند داشت.',
  selectEditAccessForSelectedBoard:
    'دسترسی ویرایش را برای بورد انتخاب شده را انتخاب کنید:',
  workflowEdited: 'گردش کار را ویرایش کرد.',
  workflowAction: 'گردش کار را {0} کرد.',
  editBoardName: 'ویرایش نام بورد',
  backToTickets: 'بازگشت به تیکت‌ها',
  editBoard: 'ویرایش بورد',
  viewSettings: 'مشاهده تنظیمات',
  productImage: 'تصویر محصول',
  versionName: 'نام نسخه',
  mainVersion: 'نسخه اصلی',
  versionImage: 'تصویر نسخه',
  noteInsertSuccessfully: 'یادداشت با موفقیت افزوده شد.',
  queuename: 'نام صف',
  dateCall: 'تاریخ تماس',
  Configuration: 'پیکربندی',
  lastInteraction: 'آخرین تعامل',
  lastInteractionDate: 'تاریخ آخرین تعامل',
  saveChangesQuestion: 'تغییرات ذخیره شود؟',
  companySize: 'اندازه شرکت',
  enterEmployeesCount: 'تعداد کارکنان را وارد کنید',
  smsRecipient: 'دریافت‌کننده پیامک',
  contactFollower: 'کارشناس پیگیری مخاطب',
  customUsers: 'کاربران دلخواه',
  selectCustomUser: 'کاربران دلخواه را انتخاب کنید',
  selectCustomUsersFirst: 'ابتدا گزینه کاربران را انتخاب کنید',
  noFileToShow: 'فایلی وجود ندارد',
  conversationWithContactHasNotYetStarted:
    'هنوز مکالمه‌ای با این مخاطب در {chatType} آغاز نشده است.',
  copied: 'کپی شد',
  boardRuleError: 'اخطار قانون برد',
  noBackwardRuleError:
    'طبق قانون این برد شما امکان بازگشت تیکت‌ها از این وضعیت به وضعیت‌های قبل را ندارید.',
  noAccessToChangeClosedTicket:
    'شما دسترسی به تغییر وضعیت این تیکت از یا به وضعیت “بسته” ندارید.',
  noSkipRuleError:
    'طبق قانون این برد شما امکان پرش تیکت از برخی وضعیت‌ها را ندارید.',
  targetStatus: 'وضعیت موردنظر',
  changeFromThisStatusToThatConfirmation1: 'آیا از تغییر وضعیت تیکت از',
  changeFromThisStatusToThatConfirmation2: 'مطمئن هستید؟',
  ticketOpen: 'بازکردن تیکت',
  permissionError: 'اخطار دسترسی',
  changeStatusAccessError: 'شما دسترسی لازم برای تغییر وضعیت را ندارید',
  personName: 'نام شخص',
  stockIn: 'وارد کردن محصول',
  stockOut: 'خارج کردن محصول',
  stockManagement: 'مدیریت محصولات',
  contactTickets: 'تیکت های مخاطب',
  deletedDepartment: 'دپارتمان حذف شده',
  personNatural: 'شخص (حقیقی)',
  companyLegal: 'شرکت (حقوقی)',
  country: 'کشور',
  street: 'خیابان',
  licensePlateNumber: 'شماره پلاک',
  birthCertificateNumber: 'شماره شناسنامه',
  nationality: 'ملیت',
  timeDuration: 'مدت زمان',
  notificationReceivers: 'دریافت‌کننده اعلان',
  timeCondition: 'شرط زمانی',
  leadDestinationdeal: 'به فرصت فروش منتقل شود',
  leadDestinationlead: 'در سرنخ باقی بماند',
  leadDestinationcontact: 'به مخاطب منتقل شود',
  oneWeek: 'یک هفته',
  twoWeek: 'دو هفته',
  oneMonth: 'یک ماه',
  twoMonth: 'دو ماه',
  threeMonth: 'سه ماه',
  afterLastArchive: ' پس از آخرین ویرایش',
  editedCount: 'تعداد موارد ویرایش شده',
  createEntityType: 'ایجاد {entityType}',
  generalSettings: 'تنظیمات کلی',
  fieldsManagement: 'مدیریت فیلدها',
  company_assign_creator_as_followup:
    'هنگام ایجاد شرکت، کاربر ایجادکننده به‌صورت خودکار به‌عنوان کارشناس پیگیری تنظیم شود.',
  company_unique_phone:
    'هنگام ایجاد شرکت، هر شماره تلفن فقط یک‌بار قابل ثبت باشد',
  people_assign_creator_as_followup:
    'هنگام ایجاد شخص، کاربر ایجادکننده به‌صورت پیش‌فرض به‌عنوان کارشناس پیگیری تنظیم شود.',
  people_unique_phone:
    'هنگام ایجاد شخص، هر شماره تلفن فقط یک‌بار قابل ثبت باشد',
  colorPalette: 'رنگبندی',
  createdLabels: 'برچسب‌های ایجاد شده',
  required: 'اجباری',
  duplicateWarning: 'اخطار ثبت تکراری',
  changesMadeSuccessfully: 'تغییرات با موفقیت اعمال شد',
  setting: 'تنظیمات',
  leadUniquePhone: 'هنگام ایجاد سرنخ، ثبت چند سرنخ با یک شماره تلفن مجاز باشد.',
  leadAssignCreatorAsFollowup:
    'هنگام ایجاد سرنخ، کارشناس ایجادکننده به‌صورت خودکار به‌عنوان کارشناس پیگیری تنظیم شود.',
  notificationBasedOnFirstAction: 'ارسال اعلان بر اساس اولین اقدام روی سرنخ',
  notificationAfterNoAction:
    'اگر پس از ایجاد سرنخ تا مدت زیر هیچ اقدامی روی سرنخ انجام نشود، اعلان خودکار برای دریافت‌کنندگان زیر ارسال شود.',
  notificationBasedOnLastContactResult:
    'ارسال اعلان بر اساس نتیجه آخرین ارتباط',
  notificationAfterLastContactResult:
    'اگر نتیجه آخرین ارتباط گزینه‌های زیر بود و تا مدت زیر بدون اقدام باقی ماند، اعلان خودکار برای دریافت‌کنندگان زیر ارسال شود.',
  autoArchiveUneditedLeads:
    'سرنخ‌هایی که در بازه زمانی زیر بدون ویرایش مانده‌اند، به‌صورت خودکار آرشیو شوند.',
  leadConversionConditions: 'شرایط تبدیل سرنخ',
  leadNotes: 'یادداشت‌های سرنخ',
  leadTable: 'جدول سرنخ',
  leadTasks: 'وظایف سرنخ',
  lastNote: 'آخرین یادداشت‌',
  editField: 'ویرایش فیلد',
  fieldType: 'نوع فیلد',
  fieldTitle: 'عنوان فیلد',
  singleSelectField: 'گزینه‌ای تک انتخابی ',
  multiSelectField: 'گزینه‌ای چند انتخابی ',
  shortTextField: 'فیلد متن کوتاه (حداکثر 255 کاراکتر)',
  enterOptionsValue: 'مقدار گزینه ها را وارد کنید: (حداقل یک گزینه وارد کنید)',
  cantCreateNewContactWithThisNumber:
    'پروفایل‌های زیر با این شماره تماس ساخته شده‌اند و طبق تنظیمات شما، شما امکان ایجاد مخاطب جدید را ندارید.',
  sameNumber: 'شماره یکسان',
  enterAtleastOneOption: 'حداقل یک گزینه وارد کنید',
  successfuldeal: 'فرصت فروش موفق',
  faileddeal: 'فرصت فروش ناموفق',
  convertedtodeal: 'فرصت فروش',
  convertedToDeal: 'فرصت فروش',
  endChat: 'پایان چت',
  globalSearchPlaceholder: 'جستجوی نام و شماره شخص، نام و شماره شرکت، ...',
  allCategories: 'همه دسته‌بندی‌ها',
  searchResults: 'نتایج جستجو',
  noResultsFound: 'نتیجه‌ای یافت نشد!',
  noResultsDescription:
    'عبارت جستجو را بررسی کنید یا عبارت دیگری را امتحان کنید!',
  searchEncounteredAProblem: 'جستجو با مشکل مواجه شد!',
  pleaseTryAgain: 'لطفاً دوباره تلاش کنید!',
  system: 'سیستم',
  payment: 'پرداخت',
  enteredCodeIsIncorrect: 'کد وارد شده صحیح نیست',
  versionNameIfAvailable: 'نام نسخه(در صورت وجود)',
  deductReason: 'علت خروج',
  deductDate: 'تاریخ خروج',
  DAMAGED: 'معیوب یا آسیب دیده',
  EXPIRED: 'منقضی شده',
  INVENTORY_SHORTAGE: 'مفقودی یا کسری انبار',
  THEFT: 'سرقت',
  INTERNAL_USE: 'مصرف داخلی',
  SUPPLIER_RETURN: 'مرجوعی به تامین کننده',
  INVENTORY_CORRECTION: 'اصلاح موجودی/مغایرت انبار',
  UNINOVICED_SALE: 'فروش بدون ثبت فاکتور',
  deductProductFromInventory: 'خروج کالا از انبار',
  deductProductFromInventoryConfirm:
    'آیا از خروج این کالاها از انبار مطمئن هستید؟',
  notEnoughStock: 'موجودی کالا در انبار کافی نیست',
  productQuantity: 'موجودی محصول',
  increased: 'افزایش داد',
  addedToInventory: 'را وارد انبار کرد',
  registerApi: 'ثبت API',
  registerPattern: 'ثبت الگو',
  registeredNumbers: 'شماره های ثبت شده',
  api_key: 'API Key',
  messenger: 'پیام‌رسان',
  testConnection: 'تست اتصال',
  melipayamak: 'ملی پیامک',
  sms_ir: 'sms.ir',
  confirmDeleteSmsApi: 'آیا از حذف API "{item}" مطمئن هستید؟',
  successfulConnection: 'اتصال موفق',
  failedConnection: 'اتصال ناموفق',
  upadatedSuccessfully: 'به‌روزرسانی با موفقیت انجام شد.',
  enterApiToConnectProviders:
    'برای اتصال با نرم افزارهای دیگر API مورد نظر را ثبت نمایید.',
  apiDeactivationConfirm:
    'آیا از {action} درگاه API {apiProvider} مطمئن هستید؟',
  deactivationConfirmBtn: 'بله,غیرفعال',
  searchByTicketNumberAndTitle: 'جستجوی شماره تیکت و عنوان',
  sendTicket: 'ارسال تیکت',
  latestResponse: 'آخرین پاسخ',
};
